{
    "headerData1": "MyHelp",
    "headerData2": "Uw AI-assistent voor IT-ondersteuning",
    "headerMessage": "Gebruik <span class='me8eon'>MyHelp</span> om IT-problemen op te lossen, stap-voor-stap-handleidingen te volgen of doorverwezen te worden naar het juiste IT-supportkanaal.",
    "loginLable": "Inloggen",
    "logOff": "Uitloggen",
    "logIn": "Inloggen",
    "userName": "Profielnaam",
    "switchLanguage": "Taal wijzigen",
    "switchRole": "Rol wijzigen",
    "new": "NIEUW",
    "whatsnew": "Bekijk wat nieuw is",
    "whatsnewtt": "Ontdek wat nieuw is in MyHelp",
    "organiseTiles": "Tegels organiseren",
    "confirm": "Bevestigen",
    "cancel": "Annuleren",
    "close": "Sluiten",
    "reset": "Resetten",
    "continue_Tour": "Tour voortzetten",
    "skip_Tour": "Tour overslaan",
    "save": "Opslaan",
    "submit": "Indienen",
    "delete": "Verwijderen",
    "trash_bin": "Verwijderen",
    "edit": "Bewerken",
    "yes": "Ja",
    "no": "Nee",
    "feedbackWidget": "Jouw feedback",
    "itSupportPrompt": "Ik heb IT-ondersteuning nodig",
    "redirectingToITSupportAgent": "Doorverwijzen naar IT-supportagent",
    "restoredWidgetNotice": "Uit een eerder gesprek. Acties zijn uitgeschakeld; vraag het opnieuw om een nieuw verzoek te starten.",
    "myITsupport": "Mijn IT-ondersteuning",
    "shareViaOutlook": "Delen via Outlook",
    "registerLable": "Registreren",
    "underDevelopmentMsg": "Deze pagina is in ontwikkeling",
    "apiFailDefaultMsg": "Er is iets misgegaan. Probeer het later opnieuw.",
    "more": "Meer",
    "searchResult": "Zoekresultaten",
    "showAll": "Alles tonen",
    "showRelevant": "Relevante tonen",
    "assistantTabTooltip": "Assistentie beantwoordt uw vragen door in real-time de interne E.ON-bronnen te doorzoeken. Het geeft duidelijke, gemakkelijk te begrijpen antwoorden met bronnen zodat u de informatie kunt vertrouwen",
    "searchTabTooltip": "E.ON Zoeken is een traditionele zoekfunctie die u helpt snel informatie te vinden uit verschillende E.ON-bronnen en uw eigen gegevens. Het biedt de meest relevante resultaten en links naar de bronnen",
    "landingPage": {
        "hello": "Hallo",
        "title": "hoe kan ik je helpen?",
        "searchApps": "Apps",
        "suggestions": "Suggesties"
    },
    "footer": {
        "imprint": "Afdruk",
        "privacyPolicy": "Privacybeleid",
        "termsofUse": "Gebruiksvoorwaarden",
        "contact": "Contact",
        "PKI": "PKI",
        "privacySettings": "Privacy-instellingen",
        "aboutMe8EON": "Over MyHelp",
        "copyrights": "Copyright inhoud"
    },
    "tilePage": {
        "backToSearch": "Terug naar vorige pagina",
        "myInboxCountSuffix": "In behandeling"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "Alle",
            "leaveApptoval": "Verlofgoedkeuring",
            "timeSheet": "Tijdregistratie",
            "claim": "Claim",
            "serviceRequest": "Serviceverzoek"
        },
        "tableData": {
            "approve": "Goedkeuren",
            "reject": "Afwijzen",
            "requestId": "Aanvraag-ID",
            "description": "Beschrijving",
            "requestedBy": "Aangevraagd door",
            "requestedType": "Aangevraagd type",
            "requestedDate": "Aanvraagdatum",
            "status": "Status"
        }
    },
    "appData": {
        "time": "Tijdregistratie",
        "meeting": "Vergaderzaalreservering",
        "approval": "Mijn goedkeuringen",
        "pr": "Aankoopaanvraag maken",
        "pra": "Geavanceerde aankoopaanvraag maken",
        "processing": "Mijn Inbox",
        "hr": "HR Portal",
        "hrLabel": "HR Portal",
        "concur": "Concur Reisboekingen en Uitgaven",
        "password": "SAP Wachtwoord Reset",
        "ariba": "Ariba - Klassiek en Klassiek+",
        "itresources": "IT Bronnen",
        "myassets": "Mijn activa",
        "order": "Bestelling",
        "incident": "Incidenten",
        "beeline": "Beeline",
        "prisma": "Prisma",
        "gertrud": "Gertrud",
        "notification": "Meldingsportal",
        "zuko": "Zuko",
        "eon_brand": "EON Merkruimte",
        "pki": "PKI Portal",
        "mail": "Mail DL",
        "journey": "Reizen/Evenementen",
        "mygenius": "MijnGenius",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": "Personeelsdossier - Digitaal Personeelsdossier - DPF",
        "corpsac": "Corporate SAC",
        "corpportal": "Corporate Portal",
        "redwood": "Redwood Financiële Automatisering",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "SoD SAP Portal",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Bankieren: Bankrekeningbeheer (EBAM)",
        "egs": "E.ON Garantieoplossing",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Risicobeheer",
        "slido": "Slido",
        "insightslibrary": "Inzichtenbibliotheek",
        "getabstract": "getAbstract",
        "mypotential": "Mijn potentieel bereiken",
        "dsesoftware": "DSE Software",
        "whistleblowing": "E.ON Klokkenluidersoplossing",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Incidentmelding",
        "cateringportal": "Menu",
        "westnetzregelwerke": "Regelwerken Westnetz",
        "werbemittel": "Promotiemateriaal",
        "westenergie_brand": "Merkbeheerportal",
        "compass": "Kompas",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM en ERM",
        "smartguide": "Slimme Gids",
        "tagetiksac": "Tagetik SAC",
        "myit": "mijn IT",
        "timehover": "Met de CATS-app kunt u eenvoudig uw werkuren en activiteiten bijhouden en beheren door alle relevante informatie en functies op één plek te hebben.",
        "meetinghover": "Met Gingco, onze kamerboekings-tool, kunt u eenvoudig uw vergaderzalen en middelen beheren en plannen, wat zorgt voor efficiënte benutting en beschikbaarheid, alles op één plek.",
        "approvalhover": "Met myInbox kunt u eenvoudig en efficiënt facturen goedkeuren door alle relevante informatie en acties op één plek te hebben.",
        "prhover": "Hier vindt u alle relevante functies om goederen en diensten aan te vragen. Dit staat ook bekend als BANF (du. voor aankoopaanvraag)",
        "prahover": "Hier vindt u alle relevante functies om goederen en diensten aan te vragen. Dit staat ook bekend als BANF (du. voor aankoopaanvraag)",
        "processinghover": "Met myInbox kunt u eenvoudig en efficiënt facturen goedkeuren door alle relevante informatie en acties op één plek te hebben.",
        "hrhover": "Met myHR kunt u gemakkelijk toegang krijgen tot en uw HR-gerelateerde informatie en taken beheren op één plek.",
        "concurhover": "Met Concur kunt u eenvoudig uw reis- en onkostendeclaraties beheren en indienen door alle relevante informatie en acties op één plek te hebben.",
        "passwordhover": "Met deze tegel kunt u eenvoudig de toegangswachtwoorden voor uw SAP-systemen resetten.",
        "aribahover": "Met SAP Ariba kunt u eenvoudig uw inkoopprocessen beheren door alle relevante informatie en tools op één plek te hebben.",
        "itresourceshover": "IT Bronnen",
        "myassetshover": "Mijn activa",
        "orderhover": "Bestelling",
        "incidenthover": "Incidenten",
        "beelinehover": "Met Beeline kunt u efficiënt uw tijdelijke personeel beheren en uw personeelsprocessen stroomlijnen door toegang te krijgen tot alle benodigde tools en informatie op één plek.",
        "prismahover": "PRISMA staat voor Platform voor Rapportage over Incidenten en Duurzaamheidsbeheer en Auditing. Het platform ondersteunt de HSE-afdeling van E.ON in haar missie om E.ON een gezondheidsbewuste, veilige en milieubewuste plek te maken. PRISMA is zowel via het web als als app beschikbaar.",
        "gertrudhover": "Gertrud",
        "notificationhover": "Meldingsportal",
        "zukohover": "Zuko",
        "eon_brandhover": "EON Merkruimte",
        "pkihover": "PKI Portal",
        "mailhover": "Mail DL",
        "journeyhover": "Reizen/Evenementen",
        "mygeniushover": "MijnGenius",
        "ideeonhover": "Idee.on is een platform waarmee medewerkers ideeën en suggesties voor ideeënbeheer kunnen indienen en evalueren. Het is ontworpen om een continu verbeterproces in alle bedrijfsgebieden te vergemakkelijken.",
        "ideenethover": "IdeeNet is ideeënbeheer software in de ware zin van het woord. Een breed scala aan ideeën, zoals &#10;&bull; Gecentraliseerde BVW, gedecentraliseerde BVW en gemengde vormen &#10;&bull; Kwaliteitscirkels en CIP &#10;&bull; Foutmeldingen en klachten &#10;&bull; Medewerkersuitvindingen &#10; kunnen efficiënt worden afgehandeld met deze software, in een uniforme ideeën database, maar met verschillende strategieën.",
        "dpfhover": "Uw personeelsdossier bevat veel meer documenten dan die permanent worden weergegeven in MyHR! &#10;Dien een HR-verzoek in en vraag toegang tot uw volledige personeelsdossier! Na een professionele beoordeling wordt het via een directe link beschikbaar gesteld.",
        "corpsachover": "SAC is een krachtig visualisatietool met geavanceerde planningsmogelijkheden",
        "corpportalhover": "Het Corporate Portal is een centraal intern applicatieplatform met rolgebaseerde applicatie-integratie en ontwikkeling voor Single-Sign-On toegang tot SAP backends.",
        "redwoodhover": "Redwood FA wordt gebruikt om de geconsolideerde jaarrekening te plannen en individuele activiteiten te automatiseren",
        "eamsap200hover": "Enterprise Asset Management &#10;Omgeving voor zelfontwikkelingen op basis van Business technology platform (BTP) van SAP (voorheen SAP Cloud Platform) - EAM-account voor grid-cockpits, inclusief de cloud-instanties: productie, QA (Quality Assurance), ontwikkeling en staging.",
        "eamsap100hover": "Enterprise Asset Management &#10;Omgeving voor zelfontwikkelingen op basis van Business technology platform (BTP) van SAP (voorheen SAP Cloud Platform) - EAM-account voor grid-cockpits, inclusief de cloud-instanties: productie, QA (Quality Assurance), ontwikkeling en staging.",
        "sodsaphover": "Het SOD-Portal is ontworpen om het beheer van Segregation of Duties (SOD) te stroomlijnen en te digitaliseren. Door het identificeren, monitoren en oplossen van SOD-conflicten te digitaliseren, zorgt het voor naleving van regelgeving en verbetert het de beveiliging van de organisatie. Deze tool is essentieel voor het handhaven van een robuust intern controlesysteem en het beschermen van uw bedrijfsactiviteiten.",
        "videonhover": "App voor het boeken van diensten van de video/TV-studio op Brüsseler Platz voor een video/TV-productie of een streaming evenement.",
        "alteryxhover": "Data-analyseplatform gebruikt voor het maken van analytische applicaties en workflows. Het stelt gebruikers in staat om analytische applicaties te beheren en te delen, workflows uit te voeren en toegang te krijgen tot en rapporteren over outputs binnen een serveromgeving.",
        "ebamhover": "Elektronisch bankrekeningbeheer",
        "egshover": "E.ON SE neemt borgstellingen en garanties over voor BU's van de groep aan externe kredietverstrekkers",
        "epsnexthover": "Centraal elektronisch banktool voor alle MU/Bus",
        "fisquantumhover": "De FIS Quantum Treasury Management Solution is ontworpen om de efficiëntie en effectiviteit van de treasury-activiteiten van uw organisatie te verbeteren. Dit cloud-native platform biedt realtime inzicht in cash en liquiditeit, waardoor betere besluitvorming over kapitaal- en risicobeheer mogelijk is. Met geavanceerde functies voor het beheren van schulden, investeringen en naleving helpt het workflows te stroomlijnen en de financiële prestaties te verbeteren.",
        "rmshover": "E.ON groep-breed risicobeheersysteem (kredietaanvraagverwerking en kredietrisicobeheersysteem)",
        "slidohover": "Slido is een interactief platform ontworpen om de betrokkenheid van het publiek te vergroten en inzichten te verzamelen tijdens live of virtuele evenementen, vergaderingen en presentaties. Het stelt gebruikers in staat om live polls, Q&A-sessies en quizzen in realtime uit te voeren, waardoor een dynamische en participatieve ervaring voor het publiek ontstaat.",
        "insightslibraryhover": "Inzichtenbibliotheek is E.ON's centrale kennisrepository voor klant- en marktinzichten binnen de klantoplossingen business.",
        "getabstracthover": "getAbstract is E.ON's groep-brede online bibliotheek, geleverd door getAbstract, met boekensamenvattingen, artikelen en verdere leerformats die alle bedrijfsrelevante vaardigheden (soft skills en functionele vaardigheden) omvatten.",
        "mypotentialhover": "Systeem voor Britse medewerkers en managers om hun prestaties, doelstellingen en beoordelingen vast te leggen.",
        "dsesoftwarehover": "Schermtraining en beoordelingen voor Gezondheid en Veiligheid",
        "whistleblowinghover": "Met de Klokkenluiders Tool kan iedereen die informatie verstrekt een rapport anoniem indienen. Dit kan worden gedaan via webintake, e-mail of telefoon. Tijdens een gesprek wordt uw stem vervormd.",
        "maqsimahover": "Beheer van risicoanalyses, bedieningsinstructies, gevaarlijke stoffen &#10;Maqsima helpt u om snel en eenvoudig alle relevante risicoanalyses en bedieningsinstructies bij te houden en op een slimme manier up-to-date te houden.",
        "digitalrulebookhover": "Paula Policy is de op AI gebaseerde assistent voor E.ON-bedrijfsbeleid en biedt medewerkers snel en eenvoudig toegang tot de People Guidelines, Function Policies en de Code of Conduct. De assistent geeft consistente en betrouwbare antwoorden en maakt complexe beleidsregels begrijpelijk en toegankelijk.",
        "oneERPhover": "Het one.ERP Portal is een centraal platform binnen de Westenergie Groep dat verschillende ERP-gerelateerde functies en informatie consolideert. Het dient als een informatie- en controlehub voor ERP-gebruikers en IT-managers en maakt deel uit van de overkoepelende digitalisatiestrategie van de groep.",
        "Perseushover": "Het Beveiligingsportal is een centraal toegangspunt voor het melden van beveiligingsgerelateerde incidenten binnen de Westenergie en Westnetz organisaties. Het wordt vaak gebruikt in combinatie met het interne Perseus meldingssysteem, dat specifiek is ontworpen om incidenten zoals apparaatverlies, diefstal of inbreuken op gegevensbescherming te behandelen.",
        "cateringportalhover": "Het portal eon.cateringportal.io is het digitale platform voor de E.ON Kantine App. Het biedt maaltijdplannen, locatiegegevens en andere cateringdiensten voor E.ON medewerkers.",
        "westnetzregelwerkehover": "Dit portal dient als een centrale bron voor technische voorschriften en documentatie met betrekking tot de werking en het beheer van de elektriciteits- en gasnetwerken. Het zorgt ervoor dat alle relevante richtlijnen, normen en technische specificaties die nodig zijn voor veilige en efficiënte netwerkactiviteiten toegankelijk zijn.",
        "werbemittelhover": "De Westenergie Promotiematerialen Winkel is een online platform waarmee medewerkers en geautoriseerde partners van de Westenergie Groep promotiematerialen en communicatiematerialen kunnen bestellen.",
        "westenergie_brandhover": "De Westenergie beeldbank evenals de merkelementen en ontwerp richtlijnen van de Westenergie Groep. Toegang tot alle componenten van ons merk om Westenergie momenten te creëren. Van het merkbeheersysteem met alle belangrijke richtlijnen voor het gebruik van merkelementen zoals logo's, symbolen en onze chatbox tot de mediatheek met talrijke afbeeldingen voor alle ontwerpvarianten.",
        "compasshover": "Kompas is het groep-brede interne communicatieplatform voor E.ON nieuws & inhoud, netwerken & medewerkersuitwisseling.",
        "gradarhover": "Deze tool wordt gebruikt om het beoordelingsproces van leidinggevende medewerkers te starten.",
        "beqomhover": "Beqom wordt groep-breed gebruikt voor het beheer en de communicatie van E.ON langetermijnincentiveplannen. Het wordt gebruikt door HR, door Accounting, door Belasting en door Executives. Naast langetermijnincentiveplanzaken kan beqom ook worden gebruikt voor het maken van loon- en bonusbrieven en totale beloningsverklaringen.",
        "kychover": "Met de Know-Your-Counterpart (KYC) tool kunt u tegenpartijen screenen volgens standaardbeleid (bijv.: PG-03).",
        "talentryhover": "Gebruik deze kans om onze huidige vacatures te delen met getalenteerde mensen in uw netwerk - mensen die willen helpen de toekomst vorm te geven met hun energie.",
        "samhover": "U kunt verplichte veiligheidstrainingen uitvoeren met deze tool.",
        "enormhover": "e-NORM is krachtige software voor het beheren, verstrekken en bijwerken van gegevens met betrekking tot kwaliteitsborging of standaarddocumenten, evenals het koppelen van bijbehorende bestanden.",
        "redonlinehover": "De Red-on-line (ROL) Compliance Monitor vereenvoudigt het beheer van naleving van regelgeving door realtime updates te bieden over milieu-, gezondheids- en veiligheidsvoorschriften (EHS). Het beschikt over monitoring en dashboards om u te helpen proactief nalevingsproblemen aan te pakken. Deze tool is essentieel voor het handhaven van een veilige en conforme werkplek, het verminderen van risico's en het verbeteren van operationele efficiëntie.",
        "tagetikcpmhover": "Tagetik Corporate Performance Management (CPM) applicatie voor budgettering & planning, consolidatie, risico en Managementrapportage (geïntroduceerd door Finance Excellence) van E.ON SE (Groepsrapportage). De belangrijkste processen zijn de kwartaalafsluitingen die een zeer hoge externe impact hebben vanwege de harde deadline voor communicatie met de kapitaalmarkt.",
        "tagetikcpmermhover": "Tagetik Corporate Performance Management (CPM) en Enterprise Risk Management (ERM) applicatie voor budgettering & planning, consolidatie, risico en Managementrapportage (geïntroduceerd door Finance Excellence) van E.ON SE (Groepsrapportage). De belangrijkste processen zijn de kwartaalafsluitingen die een zeer hoge externe impact hebben vanwege de harde deadline voor communicatie met de kapitaalmarkt.",
        "smartguidehover": "De Smart Guide Hub is een wiki die redactioneel moet worden onderhouden door enkele collega's om richtlijnen te bieden voor ongeveer 4000 gebruikers in de gebieden IFRS, Controlling, HGB en ESG.",
        "tagetiksachover": "Tagetik Dashboard. Tagetik is een applicatie voor budgettering & planning, consolidatie, risico en Managementrapportage (geïntroduceerd door Finance Excellence) van E.ON SE (Groepsrapportage). De belangrijkste processen zijn de kwartaalafsluitingen die een zeer hoge externe impact hebben vanwege de harde deadline voor communicatie met de kapitaalmarkt.",
        "myithover": "Uw go-to voor alles wat met IT te maken heeft: ondersteuningsopties, nuttige links, gemeenschappen en het laatste nieuws dat u moet weten.",
        "servicehub": "Service Hub",
        "servicehubhover": "Met EON Service Hub kunt u eenvoudig nieuwe software en hardware aanvragen, waaronder laptops en monitors, en IT-ondersteuning krijgen door problemen aan te kaarten of te chatten met de my IT support, alles op één plek.",
        "SailPoint": "Overzicht Identiteitsbeheer",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC Procesontwerp",
        "Celonis": "Celonis Proces Mining",
        "Carsync": "Carsync Vlootbeheer",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "Met SailPoint kunnen toegangsrechten en identiteiten centraal worden beheerd.",
        "P29hover": "Met SAP EIC kunnen tickets en klantvragen efficiënt worden verwerkt en gedocumenteerd. De applicatie ondersteunt integratie met ECG en biedt een centrale interface voor ticketing.",
        "P83hover": "Met SAP EIC kunnen tickets en klantvragen efficiënt worden verwerkt en gedocumenteerd. De applicatie ondersteunt integratie met ECG en biedt een centrale interface voor ticketing.",
        "BIChover": "Met BIC Cloud kunnen bedrijfsprocessen worden gemodelleerd, geanalyseerd en geoptimaliseerd.",
        "Celonishover": "Proces Mining: Analyse van werkelijke processen op basis van gebeurtenislogs van ERP, CRM en andere systemen. Uitvoeringsbeheer: Automatisering van workflows en actieaanbevelingen. Procesoptimalisatie: Identificatie van inefficiënties, bijvoorbeeld in Purchase-to-Pay of Order-to-Cash processen. Integratie: Verbinding met systemen zoals SAP, Salesforce, Oracle, enz.",
        "Carsynchover": "Met Carsync kunnen bedrijfsauto's en wagenparken efficiënt worden beheerd, ritten worden gedocumenteerd en kosten worden geoptimaliseerd.",
        "ISUSpacehover": "Met ISU/Space kunnen werkplekken en vergaderzalen eenvoudig worden geboekt en beheerd.",
        "GNIShover": "Met GNIS kunnen stamgegevens en netgegevens voor marktcommunicatie (EDI) efficiënt worden beheerd en uitgewisseld.",
        "ecount_EDIhover": "Met eccount kunnen EDI-relevante stam- en netgegevens worden beheerd, uitgewisseld en geanalyseerd.",
        "SAP_Datasphere_EDIhover": "Met SAP Datasphere kunnen gegevens uit verschillende bronnen worden geïntegreerd, gemodelleerd en beschikbaar worden gesteld voor analyses en zakelijke beslissingen. Het platform ondersteunt self-service, gegevensbeheer en realtime gegevens toegang.",
        "CFLP": "CFLP",
        "corporateWorkspace": "Corporate Workspace",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "CFLPhover": "Centrale toegangspoort voor SAP-systemen en cloudservices.",
        "corporateWorkspacehover": "SAP Build Work Zone, Advanced Edition stelt u in staat digitale werkplekoplossingen te bouwen om de productiviteit en betrokkenheid van gebruikers te verhogen. Het centraliseert de toegang tot relevante bedrijfsapplicaties, processen, informatie en communicatie in één toegangspunt dat gebruikers vanaf elk apparaat kunnen bereiken.",
        "SAPWebLaunchpadhover": "De SAP Web Launchpad biedt toegang tot SAP-systemen via het web met Fiori en WebGUI. De aanpasbare startpagina, inclusief favorieten, maakt snelle toegang tot SAP-systemen en clients mogelijk.",
        "PKI_Semnatura_Digitala_6781": "PKI - Digitale handtekening",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Personeelsbeoordeling EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Meldingen gebouwenbeheer EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Dienstreizen EER",
        "Users_Access_EER_5369": "Gebruikerstoegang EER",
        "Planificare_Concedii_EER_8588": "Verlofplanning EER",
        "Pontaje_si_Telemunca_EER_7087": "Tijdregistratie en telewerken EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Personeelsbonus",
        "GRC_Request_5510": "GRC-aanvraag",
        "iPEN_Portal_3047": "iPEN-portaal",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "IT-portaal (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264": "CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "IT-beveiligingsincident melden VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "HSE-incident melden VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Menu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "IT-meldformulier VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Verklaringen en andere HR-applicaties (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Declaraties met bedrijfskaart (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Documenten voor dienstreizen (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "Token opnieuw instellen",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Portaal personeelsbeoordeling EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Portaal meldingen gebouwenbeheer EER",
        "MRBS_EER_8445hover": "Reserveren vergaderruimte EER",
        "Delegatii_EER_1137hover": "Portaal dienstreizen EER",
        "Users_Access_EER_5369hover": "Formulier gebruikerstoegang EER",
        "Planificare_Concedii_EER_8588hover": "Verlofplanning EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Tijdregistratie en telewerken EER",
        "BOT_6231hover": "Vergoeding voor vakantie- en behandelingsvouchers",
        "Bonusare_personal_6879hover": "Personeelsbonus",
        "GRC_Request_5510hover": "GRC staat voor Governance & Risk Compliance Access Control en is een SAP-workflowtool voor het geautomatiseerd aanvragen, goedkeuren en toewijzen van gebruikersrechten in SAP-systemen.",
        "iPEN_Portal_3047hover": "Het Information Platform of Energy Networks, kortweg iPEN, zorgt ervoor dat gegevens van regionale eenheden gebundeld en centraal beschikbaar kunnen worden gesteld. Bestaande en nieuw ontwikkelde intelligente oplossingen worden op het platform aangesloten. Daardoor kunnen ze kostenefficiënt, snel en flexibel binnen de volledige netwerkgemeenschap worden uitgerold. iPEN is daarmee de centrale enabler voor het opschalen van intelligente oplossingen.",
        "YourVoiceEON_0693hover": "Het PEAKON-platform stuurt je eenmaal per week ongeveer 4-5 vragen over aspecten van je welzijn en je huidige werksituatie. Je kunt de vragen beoordelen (van 0-10), erop reageren of ze overslaan. Het beantwoorden van deze paar vragen duurt slechts ongeveer 1-2 minuten.",
        "ITPortal_5530hover": "IT-serviceportaal van Süwag",
        "Transf4m_Ticket_Tool_6635hover": "Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Menu",
        "Ariba_8690hover": "Inkoopportaal",
        "DiSch_20_0545hover": "Dit is mijn digitale werkplek",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "Confluence van Süwag",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Tijdregistratie",
        "CTP_2407hover": "CTP (Tijd is geld)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Ondersteuning voor bedrijfsprocesverwerking met Jira",
        "Qmatic_PL_CS_3195hover": "Applicatie voor het beheren van klantstromen (wachtrijen) in POS",
        "Qmatic_PL_EN_3118hover": "Applicatie voor het beheren van klantstromen (wachtrijen) in POS",
        "CCM_Inspire_7264hover": "Het gecentraliseerde Customer Communication Management (CCM)-platform van E.ON, aangedreven door Quadient Inspire, voor het creëren en leveren van klantcommunicatie.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "Dit is ons tijdregistratiesysteem",
        "Atoss_VSEGruppe_4374hover": "Dit is ons tijdregistratiesysteem",
        "AWS_Access_Portal_1318hover": "Toegang tot AWS-accounts",
        "eDIVA_5372hover": "ANF-gebruikersbeheer",
        "G2G_VSEGruppe_6518hover": "GIS-systeem van VSE-Gruppe",
        "AWS_Access_Portal_6740hover": "Toegang tot de AWS Cloud VSE-Gruppe",
        "Qualys_Security_4331hover": "Monitoring van bedrijfsrisico's",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "IT-beveiligingsincident melden VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "HSE-incident melden VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Menu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "IT-meldformulier VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Handleidingen",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "Deze applicatie helpt gebruikers om verschillende soorten verklaringen met maximaal drie klikken te downloaden. HR-beheerders en teamcoördinatoren kunnen ook verklaringen downloaden voor de collega's die onder hun verantwoordelijkheid vallen. Daarnaast kunnen medewerkers hun dienstjaren en pensioenondersteuning berekenen en andere documenten aanvragen bij de HR-afdeling.",
        "Deconturi_card_companie_RO_CS_5333hover": "Houders van bedrijfskaarten kunnen via deze applicatie eenvoudig onkostendeclaraties indienen, zonder bonnetjes per e-mail of post te versturen of goedkeuring per e-mail aan te vragen. Het hele proces vindt plaats op dit platform.",
        "Documente_delegatii_RO_CS_5332hover": "Met de applicatie voor het beheer van dienstreizen kunnen gebruikers documenten toevoegen aan hun eigen reizen en die van hun medewerkers. HR-beheerders kunnen documenten in bulk bekijken, filteren en afsluiten, en aanvullende documenten aanvragen via automatisch verzonden e-mails.",
        "SAP_ISU_CS_RO_8555hover": "De service omvat werkzaamheden rond SAP IS-U x7G-systemen die door E.ON RO CS worden gebruikt.",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Token vernieuwen / opnieuw instellen",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Portaal personeelsbeoordeling EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Portaal meldingen gebouwenbeheer EER",
            "MRBS_EER_8445subTitle": "Reserveren vergaderruimte EER",
            "Delegatii_EER_1137subTitle": "Portaal dienstreizen EER",
            "Users_Access_EER_5369subTitle": "Formulier gebruikerstoegang EER",
            "Planificare_Concedii_EER_8588subTitle": "Verlofplanning EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Tijdregistratie en telewerken EER",
            "BOT_6231subTitle": "Vergoeding voor vakantie- en behandelingsvouchers",
            "Bonusare_personal_6879subTitle": "Personeelsbonus",
            "GRC_Request_5510SubTitle": "GRC-aanvraag",
            "iPEN_Portal_3047SubTitle": "Informatieplatform van energienetwerken",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Werkplekreservering",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Inkoopportaal",
            "DiSch_20_0545SubTitle": "Digitale werkplek",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Bedrijfsactiviteitentracker",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Bedrijfsprocesverwerking",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Platform",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA ANF-gebruikersbeheer -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "IT-beveiligingsincident melden VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "HSE-incident melden VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Menu VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "IT-meldformulier VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Verklaringen en andere HR-applicaties (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Declaraties met bedrijfskaart (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Documenten voor dienstreizen (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Centrale Fiori Launchpad",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Links naar SAP-systemen",
            "timeSubTitle": "CATS",
            "meetingSubTitle": "GINGCO",
            "approvalSubTitle": "SNOW/SAP",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "processingSubTitle": "SAP",
            "hrSubTitle": "MyHR",
            "concurSubTitle": "SAP Concur",
            "passwordSubTitle": "SAP Systemen",
            "aribaSubTitle": "PO Overzicht",
            "itresourcesSubTitle": "SNOW",
            "incidentSubTitle": "SNOW",
            "orderSubTitle": "Bestel IT-diensten",
            "myassetsSubTitle": "SNOW",
            "beelineSubTitle": "Externe aanwerving",
            "prismaSubTitle": "HSE",
            "gertrudSubTitle": "Vergaderingen voorbereiden",
            "notificationSubTitle": "Facilitaire diensten",
            "zukoSubTitle": "Kantoorverhuizing organiseren",
            "eon_brandSubTitle": "het is aan ons",
            "pkiSubTitle": "Beheer certificaten",
            "mailSubTitle": "Onderhouden",
            "journeySubTitle": "FuV §37b EstG",
            "mygeniusSubTitle": "Digitale leerplatform",
            "ideeonSubTitle": "Ideeënbeheer",
            "ideenetSubTitle": "Ideeënbeheer",
            "dpfSubTitle": "Digitaal Personeelsdossier",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Corporate Portal",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "SAP Cloud Cockpits (200)",
            "eamsap100SubTitle": "SAP Cloud Cockpits (100)",
            "sodsapSubTitle": "SoD-Portal",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Kennisrepository",
            "getabstractSubTitle": "Online Bibliotheek",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "E.ON Klokkenluidersoplossing",
            "maqsimaSubTitle": "Beheer van risicoanalyses",
            "digitalrulebookSubTitle": "Groepsrichtlijnen",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Cateringportal",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Promotiematerialenwinkel",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Groep-brede interne communicatieplatform",
            "gradarSubTitle": "Functie-evaluatie en compensatie",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Compliance Tegenpartij Controle",
            "talentrySubTitle": "Vacature doorverwijzingsprogramma",
            "samSubTitle": "Veiligheidstraining @E.On",
            "enormSubTitle": "Compliance Monitor",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM en ERM",
            "smartguideSubTitle": "Smart Guide Hub (Boekhoudingswiki)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "servicehubSubTitle": "Service Hub",
            "myitSubTitle": "IT Ondersteuning en Nieuws",
            "SailPointSubTitle": "Identiteits- & Toegangsbeheer Overzicht",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Proces Mining",
            "CarsyncSubTitle": "Vlootbeheer",
            "ISUSpaceSubTitle": "Werkplek- en Ruimtebeheer",
            "GNISSubTitle": "EDI Stamgegevensbeheer",
            "ecount_EDISubTitle": "EDI Gegevensbeheer",
            "SAP_Datasphere_EDISubTitle": "Gegevensintegratie & Zakelijke Gegevensfabric",
            "ukhrSubTitle": "UK HR App"
        },
        "ukhr": "UK HR App",
        "ukhrhover": "Uw alles-in-één winkel voor alles wat met UK HR te maken heeft. Van loonstroken tot vakantieboekingen en alles daartussenin. Begin met onze gidsen voor werknemers en managers of zoek hieronder alles van HR."
    },
    "searchPage": {
        "searchPlaceholder": "Zoeken...",
        "searchApps": "Hier zoeken...",
        "relatedApps": "Apps",
        "viewMoreApps": "Meer",
        "removeAppTooltip": "Verwijderen van Dashboard",
        "addAppTooltip": "Toevoegen aan Dashboard",
        "addedAppTooltip": "Toegevoegd aan Dashboard"
    },
    "pwaText": {
        "header": "Installeer deze app op je startscherm!",
        "button": "App installeren",
        "iphoneHeader": "Om deze app op iPhone te installeren",
        "inst1": "Tik op de <b>Deel</b> knop in Safari.",
        "inst2": "Scroll naar beneden en selecteer <b>\"Voeg toe aan startscherm\".</b>",
        "inst3": "Tik op <b>Voeg toe</b> in de rechterbovenhoek."
    },
    "filterPage": {
        "filterMenu": {
            "backBtn": "Terug naar vorige pagina",
            "disclaimer": "Sommige resultaten zijn mogelijk niet volledig relevant. Gelieve zorgvuldig te beoordelen.",
            "loading": "Laden",
            "app": "Apps",
            "gitlab": "Gitlab",
            "apps": "Apps",
            "all": "Alle",
            "m365": "Mijn bestanden",
            "jql": "jql",
            "people": "Mensen",
            "emails": "Mijn e-mails",
            "teams": "Teams",
            "community": "Gemeenschap",
            "pages": "Pagina's",
            "users": "Gebruikers",
            "noData": "We konden geen resultaten vinden voor",
            "noMoreData": "Geen verdere resultaten gevonden voor uw zoekopdracht!",
            "filterHeading": "Filters",
            "reset": "Filters resetten",
            "refineResults": "Resultaten verfijnen",
            "card_languages": "Talen",
            "ecl_source_name": "Bron",
            "standard_card_type": "Type",
            "mimeType": "Type",
            "datasources": "Gegevensbronnen",
            "lookingFor": "Ik ben op zoek naar",
            "timeRange": "Tijdsbereik",
            "department": "Afdeling",
            "mygenius": "Mijn Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "Mijn IT-bestelling",
            "aiAssistant": "Assistentie",
            "space": "Ruimte",
            "time": "Tijd",
            "priority": "Prioriteit",
            "status": "Status",
            "compass": "Kompas",
            "contentType": "Categorie",
            "kb_articles": "IT-ondersteuning",
            "officeBuddy": "E.ON Kennisbank",
            "key": "Project",
            "enterSearchTerm": "Voer uw zoekwoord in en verfijn uw resultaten.",
            "categoryTags": "Categorie",
            "companyTags": "Bedrijfsgebied",
            "searchIn": "Zoeken in"
        },
        "searchResult": {
            "source": "Bron",
            "business": "Zakelijk",
            "mobile": "Mobiel",
            "type": "Type",
            "duration": "Duur",
            "category": "Categorie",
            "deliveryTime": "Levertijd",
            "availableLanguages": "Beschikbare talen",
            "status": "Status",
            "lastUpdate": "Laatste update",
            "lastUpdated": "Laatste update",
            "createdOn": "Gemaakt op",
            "createdBy": "Gemaakt door",
            "company": "Bedrijf",
            "department": "Afdeling",
            "job_title": "Functietitel",
            "office_location": "Kantoorlocatie",
            "email": "E-mail",
            "preview": "Voorbeeld",
            "viewEmail": "E-mail bekijken"
        },
        "timeRangeOptions": {
            "All": "Alle",
            "yesterday": "1 Dag",
            "lastWeek": "7 Dagen",
            "lastMonth": "1 Maand",
            "6 Months": "6 Maanden",
            "lastYear": "1 Jaar"
        },
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "JIRA": "Jira",
            "MyGenius": "MyGenius",
            "ItOrder": "mijn IT-bestelling",
            "Sharepoint": "SharePoint",
            "Knowledge Base": "Kennisbank",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Andere"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "Alle bedrijfsgebieden"
        },
        "searchOptionsHover": "Toont inhoud uit uw bedrijfsgebied, inhoud van de E.ON-groep of inhoud uit andere bedrijfsgebieden."
    },
    "chatBot": {
        "dislikeDialog": {
            "title": "Feedback delen",
            "irrelevant": "Het antwoord was niet relevant",
            "incorrect": "De informatie was onjuist",
            "detail": "Het antwoord bevatte onvoldoende details",
            "other": "Anders",
            "comments": "Aanvullende opmerkingen",
            "placeholder": "Vertel ons meer over uw feedback (optioneel)",
            "later": "Misschien later",
            "submit": "Feedback verzenden",
            "error": "De feedback kon niet worden verzonden. Probeer het opnieuw."
        },
        "chatIcon": "ChatBot",
        "sourceName": "Bron",
        "searchBack": "Terug naar vorige pagina",
        "welcomeMessage": "Chat Prompt",
        "chatbotPlaceholder": "Typ hier...",
        "sendbtn": "Versturen",
        "cancelBtn": "Annuleren",
        "showMore": "Meer weergeven",
        "showMoreTooltip": "Volledig antwoord weergeven",
        "showLess": "Minder weergeven",
        "showLessTooltip": "Volledig antwoord minimaliseren",
        "continueAssistance": "Doorgaan met Assistentie",
        "continueAssistanceTooltip": "Doorgaan met Assistentie om vervolgvragen te stellen",
        "feedbackTitle": "Was dit nuttig?",
        "feedbackThumbsUpLabel": "Ja, het hielp",
        "feedbackThumbsDownLabel": "Nog steeds hulp nodig?",
        "feedbackPrompt": "Deel uw feedback hier",
        "askMe": "Stel uw vragen",
        "imageUpload": "Afbeelding uploaden",
        "uploadImageTooltip": "Afbeelding uploaden en vraag stellen.",
        "uploadImageFormat": "Ondersteund formaat: JPG/PNG",
        "uploadImageProcessing": "Afbeelding verwerken...",
        "uploadImageQuestions": "Voorgestelde vragen:",
        "card": {
            "selfService": "Zelfbediening",
            "efficiency": "Efficiëntie",
            "ngService": "Next-Gen Service"
        },
        "disclaimerText": "Houd er rekening mee dat alle antwoorden door AI worden gegenereerd en fouten kunnen bevatten.",
        "selfServiceTitle": "IT Ondersteuning",
        "selfServiceContent": "AI-ondersteunde zelfbediening voor snelle incidentoplossing",
        "knowledgeBaseTitle": "Kennisbank",
        "knowledgeBaseContent": "Verbetering van de werknemerservaring door middel van informatie",
        "internetSearchTitle": "Algemene vragen",
        "wentWell": "Wat ging goed? (optioneel)",
        "wentWrong": "Wat ging niet goed?",
        "privacyMsg": "We respecteren privacy en we verzekeren dat feedbacks vertrouwelijk worden behandeld.",
        "appreciateService": "We waarderen uw hulp bij het verbeteren van onze diensten.",
        "feedbackMessage": "Bedankt voor uw feedback!",
        "relevantSearches": "Meest relevante zoekopdrachten",
        "aiAssitanceSuggestion": "U kunt uw vragen stellen aan AI Assistentie via het invoerveld hieronder",
        "aiActionMsg": "Het lijkt erop dat uw interne opslag vol is. Ik kan u helpen het installatieprobleem op te lossen door automatisch uw tijdelijke bestanden te verwijderen en uw prullenbak te legen. Wilt u dat ik automatisch opruim?",
        "aiActionPrimaryBtn": "Automatisch opruimen",
        "aiActionSecondaryBtn": "Niet automatisch opruimen",
        "aiActionSuccess": "Uw opslag is opgeruimd.",
        "aiActionFailed": "Er is iets misgegaan. Probeer het later opnieuw. Of probeer het handmatig.",
        "hey": "Hoi",
        "topicStartMessage": "met welk IT-probleem kan ik je vandaag helpen?",
        "commonItIssues": "Veelvoorkomende IT-problemen",
        "newChat": "Nieuwe Chat",
        "open": "Openen",
        "close": "Sluiten",
        "recentChats": "Recente chats",
        "ask": "Vraag",
        "internet": "Internet",
        "askEon": "Vraag E.ON",
        "askInternet": "Vraag Internet",
        "askFollowUpQuestion": "Stel een vervolgvraag",
        "resolveIssue": "Feedbackindiening zal ondersteuningsacties mogelijk maken",
        "resolveIssueAfterFeedback": "Sorry dat ik uw probleem niet kon oplossen. Hoe wilt u dat ik u verder help?",
        "differentiator": "of",
        "incident": "Service ticket aanmaken",
        "creatingIncident": "Incident aanmaken",
        "liveAgent": "Chatten met een agent",
        "requestCallbackBtn": "Terugbelverzoek",
        "ticketDescription": "Ticketbeschrijving op basis van recente discussie",
        "createIncident": "Incident aanmaken",
        "confirmCreateIncident": "Bevestigen en incident aanmaken",
        "editCreateIncident": "Bewerken en incident aanmaken",
        "ticketSuccessMsg": "Uw incident is succesvol aangemaakt, Ticketnummer: ",
        "ticketErrorMsg": "Er is iets misgegaan. Probeer het later opnieuw.",
        "chatBotTitle": "Gebruik MyHelp-assistentie om een vraag te stellen, ondersteuning te krijgen en nuttige informatie van interne en externe bronnen te verkrijgen.",
        "duplicateError": "Dubbele vraag, stel een andere vraag",
        "content": "Inhoud",
        "tone": "Toon",
        "information": "Informatie",
        "complete": "Volledig",
        "other": "Andere",
        "irelevantContent": "Irrelevante inhoud",
        "lackOfDetail": "Gebrek aan detail",
        "incorrectInformation": "Onjuiste informatie",
        "copyLink": "Link kopiëren",
        "openLink": "Link openen",
        "internetSearchContent": "Gebaseerd op vraag me alles EON gpt",
        "assignmentGroupForTicket": "eon-uk-gsd",
        "copy": "Kopiëren",
        "share": "Delen",
        "copiedMsg": "Succesvol gekopieerd",
        "copyLinkMsg": "Link kopiëren",
        "sharableLink": "Deelbare link",
        "uploadImage": "Afbeelding uploaden en vraag stellen",
        "liveAgentChat": {
            "connectWithLiveAgent": "Verbinden met my IT support",
            "connectingWithLiveAgent": "Verbinden met my IT support",
            "connectingHint": "U kunt terugschakelen naar Assistentie door op de link onder het chatvenster te klikken",
            "agentLeftMsg": "Bedankt voor het contacteren van E.ON",
            "switchToAssistance": "Chat afsluiten en overschakelen naar assistentie",
            "typeMessageHint": "Typ uw bericht hier...",
            "disconnectingMsg": "Chat afsluiten en overschakelen naar assistentie",
            "continue": "Doorgaan",
            "exitChat": "Chat afsluiten",
            "chatSessionEndPrompt": "Chatsessie wordt automatisch beëindigd in <timer>"
        },
        "requestCallback": {
            "languageConfirmation": "MyHelp Assistentie heeft gedetecteerd dat uw standaardtaal “<language>” is. Bevestig om verbonden te worden met een agent of wijzig de gewenste taal en agenttype hieronder.",
            "channelsText": "Terugbelverzoek ontvangen via",
            "languageText": "Communicatietaal",
            "channelLabel": "Selecteer kanaal",
            "phoneLabel": "Verbind me via",
            "languageLabel": "Selecteer taal",
            "tryAgain": "Probeer opnieuw",
            "technicalIssue": "Kan uw terugbelverzoek niet voltooien vanwege een technisch probleem. Probeer het opnieuw.",
            "newNumber": "Nieuw nummer",
            "availableMobileNumbers": "Beschikbare mobiele nummers",
            "chosenNumber": "Verbind me op dit nummer",
            "phoneError": "Voer een geldig contactnummer in",
            "referenceNumber": "Referentienummer",
            "tooltip": {
                "confirmBtn": "Bevestig om een terugbelverzoek te plaatsen",
                "resetBtn": "Reset het formulier om alle selecties te wissen en opnieuw te beginnen",
                "cancelBtn": "Terugbelverzoek annuleren"
            },
            "addNewNumber": "nieuw nummer"
        },
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Ticket aanmaken",
                "chatWithServiceDesk": "Live chat starten",
                "requestCallback": "Teruggebeld worden",
                "ongoingConversation": "Ja, het maakt deel uit van mijn laatste gesprek.",
                "newConversation": "Nee. Ik heb hulp nodig bij het oplossen van een nieuw probleem",
                "confirmAndCreateTicket": "Bevestigen en ticket aanmaken",
                "cancelTicketCreation": "Ticketaanmaak annuleren",
                "confirmChatWithServiceDesk": "Bevestigen en verbinden met my IT support",
                "cancelChatWithServiceDesk": "Chat met my IT support annuleren",
                "cancelRequestCallback": "Terugbelverzoek annuleren",
                "confirmRequestCallback": "Bevestigen om te verbinden via <channel> <phone> met een my IT support Agent in <language> taal"
            },
            "state": {
                "whatsTheIssue": "Wat is het probleem dat u wilt oplossen?",
                "lastConversation": "Zeker, is het probleem onderdeel van het laatste gesprek?",
                "createIncidentLabel": "U staat op het punt een incidentticket aan te maken voor",
                "cancelAck": "Genoteerd. Kan ik u helpen met een ander probleem?",
                "chatWithServiceDeskLabel": "U staat op het punt verbinding te maken met een my IT support agent",
                "createTicketLabel": "Bevestigen en ticket aanmaken",
                "cancelTicketLabel": "Ticketaanmaak annuleren",
                "creatingIncidentTicket": "Incidentticket aanmaken",
                "ticketAttachment": "Voeg een screenshot van de fout of het probleem toe.",
                "ticketAttachmentTooltipInstruction": "Druk op Windows-logotoets + Printscreen of gebruik de kniptool om een afbeelding te maken.",
                "ticketAttachmentTooltipWarning": "Afbeeldingsgrootte moet minder dan 5MB zijn",
                "ticketAttachmentLabel": "Voeg een screenshot toe",
                "ticketAttachmentTitle": "Toegevoegde screenshot voor ticket",
                "ticketAttachmentError": "Kan het geselecteerde bestand niet bijvoegen. Zorg ervoor dat het bestand in jpg- of png-formaat is en minder dan 5MB.",
                "ticketAttachmentErrorAction": "Probeer opnieuw",
                "ticketDescription": "Ticketbeschrijving",
                "ticketNonITWarning": "Assistentie heeft geen trefwoorden gevonden om uw probleem als IT-gerelateerd te identificeren.",
                "ticketNonITWarningQuestion": "Wilt u een incident aanmaken bij de my IT support op basis van uw gesprek over",
                "ticketNonITWarningRecommendationLabel": "Aanbeveling:",
                "ticketNonITWarningRecommendationText": "als u een probleem heeft dat niet gerelateerd is aan software of hardware, kunt u proberen uw zoekopdracht opnieuw te formuleren of een vervolgvraag hieronder te stellen",
                "connectWithServiceDeskLabel": "Bevestigen om te chatten met my IT support",
                "requestCallbackLabel": "Terugbellen aanvragen",
                "requestCallbackInQueuePhone": "Uw terugbelverzoek is verzonden. U wordt binnen ongeveer 5 minuten gecontacteerd via <strong><phone></strong>. Tijdens het wachten kunt u andere applicaties blijven gebruiken.",
                "requestCallbackInQueueTeams": "Uw terugbelverzoek is verzonden. U wordt binnen ongeveer 5 minuten gecontacteerd via <strong>Microsoft Teams</strong>. Tijdens het wachten kunt u andere applicaties blijven gebruiken.",
                "requestCallbackFailed": "We konden uw terugbelverzoek niet voltooien vanwege een technisch probleem. Probeer het opnieuw.",
                "requestCallbackPromptAnswer": "U staat op het punt een terugbelverzoek aan te vragen bij my IT support",
                "requestCallbackConfirmLabel": "Bevestigen om een terugbelverzoek aan te vragen"
            },
            "tooltips": {
                "createIncident": "Helpt u door een IT-probleem op te lossen en indien nodig een incident bij de servicedesk aan te maken",
                "chatWithServiceDesk": "Helpt u door een IT-probleem op te lossen en indien nodig via chat contact op te nemen met de servicedesk",
                "requestCallback": "Terugbelverzoek van my IT support"
            }
        },
        "askTooltip": {
            "eon": "Verkrijg bedrijfsspecifieke informatie uit interne bronnen",
            "internet": "Verkrijg informatie uit interne en externe bronnen zoals E.ON GPT"
        },
        "jiraIntegration": {
            "viewInJira": "Bekijk in Jira",
            "responseHeading": "Hier is uw Jira-ticketsamenvatting:",
            "responseSubheading": "Top 15 records weergegeven",
            "noResponse": "Het lijkt erop dat er momenteel geen JIRA-tickets beschikbaar zijn voor uw verzoek.",
            "supportedQuestionMsg": "Hoi, het spijt me. Ik begreep uw vraag niet helemaal. Kunt u het opnieuw formuleren? Ik deel enkele voorbeeldvragen om u te helpen:"
        },
        "intune": {
            "selectDevice": "Selecteer een apparaat",
            "changeBrowserHomePage": "Startpagina van browser wijzigen",
            "fixWillBeApplied": "De oplossing wordt toegepast op dit systeem",
            "confirm": "Bevestigen",
            "fixThis": "Los dit op",
            "enterDeviceName": "Voer de naam van het apparaat in",
            "selectOrEnterDevice": "Selecteer een apparaat of voer de naam van uw apparaat in.",
            "actionFailed": "Actie mislukt.",
            "working": "Bezig...",
            "fixOnThis": "Toepassen op dit apparaat",
            "deviceLabel": "Apparaat",
            "lastActive": "Laatst actief",
            "today": "Vandaag",
            "yesterday": "Gisteren",
            "daysAgo": "dagen geleden",
            "deviceTypeLaptop": "Laptop",
            "deviceTypeDesktop": "Desktop",
            "deviceTypeVirtualMachine": "Virtuele machine",
            "deviceTypeUnknown": "Apparaat",
            "homepageBrowserChange": {
                "syncInstructions": "De wijziging wordt nu op uw apparaat toegepast. Dit kan ongeveer 90 minuten duren. Als u het proces wilt versnellen, kunt u een handmatige synchronisatie starten vanuit Company Portal:\n1. Open Company Portal\n2. Klik linksonder op Settings naast het tandwielsymbool.\n3. Klik vervolgens op de blauwe knop \"Synchronize\" en wacht tot de synchronisatie is voltooid.",
                "changeHomepageInstructions": "1. Klik op de drie puntjes (...) rechtsboven.\n2. Selecteer “Instellingen”.\n3. Selecteer in het linkermenu “Start, startpagina en nieuw tabblad”.\n4. Controleer onder “Bij opstarten” of “Aangepaste sites openen” is geselecteerd/aangevinkt.\n5. Klik daarna op “Site toevoegen”.\n6. Voer het websiteadres in dat u als nieuwe startpagina in Microsoft Edge wilt instellen (bijvoorbeeld: https://compass.eon.com/).\n7. Klik op “Toevoegen”.\n\nAls u een site uit de Startpagina-lijst wilt verwijderen, klikt u op de drie puntjes (...) naast de site en daarna op “Verwijderen”.",
                "policyDescription": "Uw organisatie beheert momenteel de instellingen van de browserstartpagina via apparaatbeleid. Om het wijzigen van de startpagina mogelijk te maken, moeten we eerst vaststellen welk apparaat de beleidsupdate moet ontvangen.",
                "deviceSelectedForPolicy": "geselecteerd voor het ontgrendelen van het startpaginabeleid",
                "stepsForEdge": "Stappen om de startpagina in de Microsoft Edge-browser te wijzigen",
                "whatsNextTitle": "Wat gebeurt er hierna?",
                "whatsNextSubmitted": "Er is een verzoek om een aanpasbare startpagina toe te staan ingediend bij de beleidswachtrij van uw apparaat. ",
                "whatsNextSyncTime": "<strong>90 minuten</strong> gemiddelde synchronisatietijd nodig voor de vernieuwing van het achtergrondbeleid. ",
                "whatsNextReturn": "Ga na 90 minuten terug naar uw browserinstellingen en voer de onderstaande stappen uit. ",
                "homepageEnabled": "U kunt nu de startpagina-instellingen van uw browser wijzigen. Houd er rekening mee dat de wijziging mogelijk niet onmiddellijk van kracht is. Wacht ongeveer 30 minuten totdat de synchronisatie heeft plaatsgevonden, sluit vervolgens Edge en open het opnieuw.",
                "homepageAlreadyEnabled": "Uw apparaat heeft al de startpagina-wijziging ingeschakeld. Ga naar de browserinstellingen en probeer het opnieuw.",
                "homepageEnableFailed": "Ik kon de startpagina-wijziging op dit moment niet inschakelen. Probeer het later opnieuw.",
                "homepageRemoved": "Apparaat verwijderd uit het startpagina-beleidsgroep."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Oeps! Er is iets misgegaan. Probeer het later opnieuw. Als het probleem aanhoudt, dien dan een probleem in via Snelle Acties",
            "assistanceTask": "Assistentietaak",
            "myActions": "Mijn Acties",
            "itReportTitle": "Hier is uw systeemefficiëntie snapshot",
            "days": "Dagen",
            "device": "Apparaat",
            "sinceRestarted": "sinds opnieuw gestart",
            "deviceRestartRecommendation": "Onmiddellijke herstart van apparaat wordt aanbevolen",
            "deviceInCompliance": "Uw apparaat voldoet aan de normen",
            "energyConsumed": "Energieverbruik in de afgelopen 7 dagen",
            "coEmitted": "CO2-uitstoot in de afgelopen 7 dagen",
            "cacheActionMsg": "Herstart uw browser om de wijzigingen door te voeren.",
            "diskClean": {
                "primaryBtn": "Ja, maak mijn schijf nu schoon",
                "secondaryBtn": "Niet nu schoonmaken",
                "successMsg": "Uw schijf is schoongemaakt",
                "successMsgOnList": "Uw schijf is schoongemaakt",
                "failureMsg": "Uw schijf kon op dit moment niet worden schoongemaakt",
                "progressMsg": "Opslag opruimen in uitvoering",
                "disclaimer": "Houd er rekening mee dat we uw persoonlijke of werkgegevens niet aanraken. Terwijl de schoonmaak op de achtergrond plaatsvindt, kunt u gerust gebruik maken van assistentie.",
                "acknowledgeQuery": "Ik kan een opschoning van de schijf voor u uitvoeren. Tijdens de schijfopschoning worden onnodige bestanden, caches of oude logboeken op uw systeem opgeschoond. Klik op de onderstaande knop om door te gaan."
            },
            "chromeCache": {
                "primaryBtn": "Ja, wis nu de Chrome-cache",
                "secondaryBtn": "Nu niet de Chrome-cache wissen",
                "successMsg": "Uw Chrome-cache is schoongemaakt. Herstart uw browser om de wijzigingen door te voeren.",
                "successMsgOnList": "Uw Chrome-cache is schoongemaakt",
                "failureMsg": "Uw Chrome-cache kon op dit moment niet worden schoongemaakt",
                "progressMsg": "Chrome-cache opruimen in uitvoering",
                "disclaimer": "Houd er rekening mee dat we uw persoonlijke of werkgegevens niet aanraken. Terwijl de schoonmaak op de achtergrond plaatsvindt, kunt u gerust gebruik maken van assistentie.",
                "acknowledgeQuery": "Ik kan u helpen de browsercache te wissen. Klik op de onderstaande knop om door te gaan."
            },
            "edgeCache": {
                "primaryBtn": "Ja, wis nu de Edge-cache",
                "secondaryBtn": "Nu niet de Edge-cache wissen",
                "successMsg": "Uw Edge-cache is schoongemaakt. Herstart uw browser om de wijzigingen door te voeren.",
                "successMsgOnList": "Uw Edge-cache is schoongemaakt",
                "failureMsg": "Uw Edge-cache kon op dit moment niet worden schoongemaakt",
                "progressMsg": "Edge-cache opruimen in uitvoering",
                "disclaimer": "Houd er rekening mee dat we uw persoonlijke of werkgegevens niet aanraken. Terwijl de schoonmaak op de achtergrond plaatsvindt, kunt u gerust gebruik maken van assistentie.",
                "acknowledgeQuery": "Ik kan u helpen de browsercache te wissen. Klik op de onderstaande knop om door te gaan."
            },
            "empowerPlugin": {
                "progressMsg": "Verzoek voor Empower-plugin wordt uitgevoerd",
                "successMsgOnList": "Verzoek voor Empower-plugin voltooid",
                "failureMsg": "Verzoek voor Empower-plugin kon niet worden voltooid"
            },
            "empowerApp": {
                "primaryBtn": "Ja, repareer nu",
                "secondaryBtn": "Nu niet repareren",
                "successMsg": "Automatische reparatie succesvol voltooid",
                "successMsgOnList": "Automatische reparatie succesvol voltooid",
                "failureMsg": "Uw Empower Plugin kon op dit moment niet worden gerepareerd",
                "progressMsg": "Automatische reparatie is in uitvoering",
                "disclaimer": "We zullen de Empower-plugin opnieuw installeren. Sluit al uw O365-apps voordat u verder gaat.",
                "acknowledgeQuery": "Ik kan u helpen met problemen met de Empower-add-in. Klik hieronder om de Empower-add-in te repareren."
            },
            "teamsCache": {
                "primaryBtn": "Ja, wis nu de Teams-cache",
                "secondaryBtn": "Nu niet de Teams-cache wissen",
                "successMsg": "Uw Teams-cache is schoongemaakt. U kunt Teams openen en eventuele instellingen die zijn gereset opnieuw configureren.",
                "successMsgOnList": "Uw Teams-cache is schoongemaakt",
                "failureMsg": "Uw Teams-cache kon op dit moment niet worden schoongemaakt",
                "progressMsg": "Teams-cache opruimen in uitvoering",
                "disclaimer": "Houd er rekening mee dat we uw persoonlijke of werkgegevens niet aanraken. Terwijl de schoonmaak op de achtergrond plaatsvindt, kunt u gerust gebruik maken van assistentie.",
                "acknowledgeQuery": "Ik kan u helpen de Teams-cache te wissen. Klik op de onderstaande knop om door te gaan."
            },
            "teamsReinstall": {
                "primaryBtn": "Ja, Teams opnieuw installeren",
                "secondaryBtn": "Nu niet Teams opnieuw installeren",
                "successMsg": "Teams-app opnieuw installeren is voltooid",
                "successMsgOnList": "Teams-app opnieuw installeren is voltooid",
                "failureMsg": "Teams opnieuw installeren kon niet worden voltooid",
                "progressMsg": "Teams opnieuw installeren in uitvoering",
                "disclaimer": "Houd er rekening mee dat dit tegelijkertijd de Teams-app downloadt en opnieuw installeert. Dit zal de Teams-app opnieuw starten, sla uw werk op voordat u verder gaat.",
                "acknowledgeQuery": "Het opnieuw installeren van de Microsoft Teams-app kan het probleem verhelpen. Klik op de onderstaande knop om door te gaan."
            },
            "outlookOst": {
                "primaryBtn": "Ja, repareer Outlook",
                "secondaryBtn": "Nu niet Outlook repareren",
                "successMsg": "Outlook-profiel opnieuw gemaakt",
                "successMsgOnList": "Outlook-profiel opnieuw gemaakt",
                "failureMsg": "Outlook-profiel kon niet opnieuw worden gemaakt",
                "progressMsg": "Outlook-profiel opnieuw maken",
                "disclaimer": "Het uitvoeren van deze actie zal uw Outlook-profiel lokaal opnieuw maken, dit zal het downloaden van e-mails van Office Exchange initiëren, zorg ervoor dat er voldoende netwerkbandbreedte en opslag beschikbaar is.",
                "acknowledgeQuery": "Dit kan worden veroorzaakt door verbindingsproblemen of verouderde instellingen. Ik kan u helpen het probleem op te lossen en uw Outlook weer te synchroniseren."
            },
            "repairOfficeApps": {
                "primaryBtn": "Ja, repareer Office-apps",
                "secondaryBtn": "Nu niet Office-apps repareren",
                "successMsg": "Office-apps gerepareerd",
                "successMsgOnList": "Office-apps gerepareerd",
                "failureMsg": "Office-applicaties konden niet worden gerepareerd",
                "progressMsg": "Office-apps worden opnieuw geïnstalleerd",
                "disclaimer": "Het uitvoeren van deze actie zal tegelijkertijd Office-apps opnieuw installeren en proberen ze te repareren, sla al uw niet-opgeslagen werk op voordat u verder gaat.",
                "acknowledgeQuery": "Dit kan worden veroorzaakt door een beschadigde installatie of een compatibiliteitsprobleem. Ik kan u helpen Office-apps te repareren zodat uw apps weer soepel openen."
            },
            "intuneSync": {
                "primaryBtn": "Ja, start intune synchronisatie",
                "secondaryBtn": "Nu niet synchroniseren",
                "successMsg": "Intune synchronisatie is voltooid",
                "successMsgOnList": "Intune synchronisatie is voltooid",
                "failureMsg": "Intune synchronisatie kon niet worden gestart",
                "progressMsg": "Intune synchronisatie in uitvoering",
                "disclaimer": "Houd er rekening mee dat deze actie alleen Intune synchronisatiediensten opnieuw start, dit herinstalleert of repareert Intune (Bedrijfsportaal) niet.",
                "acknowledgeQuery": "Ik kan u helpen de status van uw apparaat te vernieuwen en het te synchroniseren met Intune, zodat het compliant is, up-to-date is en de nieuwste beleidsinstellingen toepast."
            },
            "teamsAddin": {
                "primaryBtn": "Ja, schakel MS Teams add-in in",
                "secondaryBtn": "Nu niet de add-in inschakelen",
                "successMsg": "MS Teams add-in reparatie is voltooid",
                "successMsgOnList": "MS Teams add-in reparatie is voltooid",
                "failureMsg": "MS Teams add-in kon niet worden ingeschakeld",
                "progressMsg": "MS Teams add-in wordt ingeschakeld",
                "disclaimer": "Houd er rekening mee dat het repareren van de MS Teams add-in vereist dat Outlook opnieuw wordt gestart. Sla al uw werk op voordat u verder gaat.",
                "acknowledgeQuery": "Ik kan u helpen de Teams-add-in in Outlook te herstellen, zodat u weer vergaderingen kunt plannen. Klik op de onderstaande knop om door te gaan."
            },
            "windowsUpdate": {
                "primaryBtn": "Ja, controleer op updates",
                "secondaryBtn": "Nee, niet controleren",
                "successMsg": "Windows Update is gestart",
                "successMsgOnList": "Windows Update is gestart",
                "failureMsg": "Kan Windows Update niet starten",
                "progressMsg": "Controleren op updates",
                "disclaimer": "Deze actie is ontworpen om updates van Microsoft te controleren en te downloaden, zorg ervoor dat u verbonden bent met een geschikt netwerk om updates te downloaden.",
                "acknowledgeQuery": "Ik kan u helpen problemen met Windows Update en compliance op uw apparaat op te lossen. Klik op de onderstaande knop om door te gaan."
            },
            "smartSolution": {
                "systemName": "Systeemnaam",
                "primaryBtn": "Healthcheck uitvoeren",
                "secondaryBtn": "Niet nu",
                "askToRunHealthCheck": "Wilt u dat de assistentie een snelle gezondheidscontrole uitvoert?",
                "healthCheckApiRunning": "Analyseren en gezondheidscontrole uitvoeren op",
                "healthCheckApiFail": "Kon geen gezondheidscontrole-informatie ophalen, probeer het opnieuw",
                "healthCheckApiSuccess": "Ik heb het systeem geanalyseerd. De volgende problemen blijven bestaan:",
                "systemCheckMsg": "Systeemcontrole in uitvoering",
                "systemCheckMessages": {
                    "recentlyStarted": "Systeem is up-to-date en onlangs gestart",
                    "appsHealthy": "Alle app-installaties zijn gezond",
                    "driveSpace": "Voldoende vrije ruimte op systeemschijf beschikbaar",
                    "noCrashes": "Geen recente applicatiecrashes gedetecteerd"
                },
                "healthCheckNoIssue": "Ik heb het systeem geanalyseerd. <b>Alles lijkt goed te werken.</b>",
                "recommendedActionHeading": "Aanbevolen Acties",
                "askForElaboration": "U kunt ook het specifieke probleem toelichten of een screenshot van het probleem dat u ondervindt uploaden.",
                "remindForSystemCheck": "Oké, u kunt het me laten weten wanneer u een systeemcontrole wilt uitvoeren.",
                "recommendedFixesHeading": "Aanbevolen Oplossingen",
                "recommendedActionInfo": "Selecteer of deselecteer de voorgestelde oplossingen, indien nodig",
                "noRecommendedAction": "Geen aanbevolen acties beschikbaar",
                "initiateActionsButton": "Begin met oplossen",
                "selectedActionsProgress": "Geselecteerde acties worden verwerkt.",
                "selectedActionsProgressNote": "Voel u vrij om de assistentie te gebruiken terwijl de actie wordt uitgevoerd. Uw actie-item is toegevoegd aan de assistentietaaklijst en u kunt de voortgang controleren. U wordt op de hoogte gebracht zodra de actie is voltooid.",
                "selectedActionsCompleted": "Geselecteerde acties succesvol voltooid.",
                "selectedActionsFailed": "Geselecteerde acties mislukt. Controleer de Assistentietaakkaart voor details.",
                "selectedActionsPartiallyCompleted": "Geselecteerde acties zijn gedeeltelijk voltooid. Controleer de Assistentietaakkaart voor details.",
                "myActionDone": "Markeren als voltooid",
                "manualActionDisclaimer": "Dit proces omvat zowel geautomatiseerde als handmatige stappen. Voltooi acties wanneer daarom wordt gevraagd",
                "manualActionNotification": "Om de oplossing te voltooien, voert u aanvullende stappen handmatig uit die worden vermeld onder 'Mijn Acties'.",
                "deviceSelectionHeading": "Ik zie dat u meerdere systemen gebruikt. Als u de volgende actie op een ander systeem wilt uitvoeren, kies dan uit de onderstaande lijst.",
                "deviceSelectionLabel": "Kies het systeem voor Nexthink-actie",
                "alerts": {
                    "successTitle": "Taak voltooid!",
                    "successMessage": "Geselecteerde acties zijn succesvol voltooid.",
                    "errorTitle": "Taak mislukt!",
                    "errorMessage": "Er was een fout bij het verwerken van uw geselecteerde actie.",
                    "partialTitle": "Taak gedeeltelijk voltooid",
                    "partialMessage": "Geselecteerde acties zijn gedeeltelijk voltooid. Controleer de Assistentietaakkaart voor details."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "Er zijn <n> gevallen van blauwe schermen op uw apparaat geweest in de afgelopen 7 dagen.",
                        "action": "Neem contact op met GSD voor verdere hulp",
                        "actionInfo": "(Geen actie) neem contact op met GSD voor verdere assistentie"
                    },
                    "edgeCrashes": {
                        "message": "We hebben bewijs gevonden van <n> Edge-browsercrashes in de afgelopen 7 dagen. We zullen proberen dit te verhelpen door een script op uw machine uit te voeren.",
                        "action": "Wis Edge-browsercache",
                        "actionInfo": "Dit wist Edge-browsercaches en geen persoonlijke bestanden worden gewijzigd"
                    },
                    "chromeCrashes": {
                        "message": "We hebben bewijs gevonden van <n> Chrome-browsercrashes in de afgelopen 7 dagen. We zullen proberen dit te verhelpen door een script op uw machine uit te voeren.",
                        "action": "Wis Chrome-browsercache",
                        "actionInfo": "Dit zal uw Chrome-cache wissen, geen bestaande bestanden worden gewijzigd."
                    },
                    "ZScalarStatus": {
                        "message": "We hebben ontdekt dat de Zscaler-service enkele problemen had op uw apparaat. We kunnen proberen dit te verhelpen door een script op uw machine uit te voeren.",
                        "action": "Herstart Zscaler-service",
                        "actionInfo": "Deze actie zal de netwerkverbinding opnieuw starten. Het heeft geen invloed op uw open programma's."
                    },
                    "ZScalarState": {
                        "message": "We hebben ontdekt dat de Zscaler-service enkele problemen had op uw apparaat. We kunnen proberen dit te verhelpen door een script op uw machine uit te voeren.",
                        "action": "Reset Zscaler",
                        "actionInfo": "Deze actie zal de netwerkverbinding opnieuw starten. Het heeft geen invloed op uw open programma's."
                    },
                    "driveFreeSpace": {
                        "message": "Uw apparaat heeft nog maar <n> GB vrije ruimte over. Om een optimaal presterende computer te garanderen, raden we aan de hoeveelheid vrije ruimte die Windows kan gebruiken te vergroten door een script op uw machine uit te voeren.",
                        "action": "Voer schijfopruiming uit",
                        "actionInfo": "Alleen uw tijdelijke bestanden en prullenbak van uw apparaat worden in de actie schoongemaakt"
                    },
                    "daysSinceFullBoot": {
                        "message": "Uw apparaat is de afgelopen <n> dagen niet volledig opnieuw opgestart. Dit is anders dan de normale afsluitprocedure. We raden aan uw computer volledig opnieuw te starten (Start | Afsluiten | Opnieuw starten)",
                        "action": "Herstart apparaat op uw vroegst mogelijke gelegenheid.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "We hebben bewijs gevonden van <n> gerelateerde Microsoft Teams-crashes in de afgelopen 7 dagen. We kunnen proberen dit te verhelpen door een script uit te voeren om uw Microsoft Teams-cache te wissen.",
                        "action": "Voer Teams-cacheopruiming uit",
                        "actionInfo": "Deze actie wist uw MS Teams-cache en start het opnieuw. Dit kan ook concept-/niet-verzonden Teams-berichten verwijderen."
                    },
                    "teamsPluginDisabled": {
                        "message": "We hebben gedetecteerd dat uw Microsoft Teams-add-in binnen Microsoft Outlook. Dit veroorzaakt problemen tussen de 2 applicaties. We kunnen proberen dit te verhelpen door een script uit te voeren om deze instellingen opnieuw te configureren.",
                        "action": "Stel Outlook-plug-ins in",
                        "actionInfo": "Deze actie schakelt de Teams-plug-in in uw Outlook in en start de app opnieuw."
                    },
                    "outlookOstStatus": {
                        "message": "Uw Outlook-profiel heeft zijn optimale grootte overschreden, wat bekend staat om problemen met uw mailbox te veroorzaken. We kunnen proberen dit te verhelpen met een script om dit bestand opnieuw te maken.",
                        "action": "Repareer Outlook OST-bestand",
                        "actionInfo": "Dit hernoemt uw Outlook OST-bestand en start de app opnieuw. Het zal concept-e-mails verwijderen."
                    },
                    "lastOsUpdate": {
                        "message": "We kunnen zien dat uw Windows Update-service niet werkt zoals verwacht, en uw machine is voor het laatst bijgewerkt <n> dagen geleden. We raden aan uw computer volledig opnieuw te starten (Start | Afsluiten | Opnieuw starten) wat helpt om enkele instellingen te resetten.",
                        "action": "Herstart apparaat op uw vroegst mogelijke gelegenheid",
                        "actionInfo": ""
                    }
                },
                "acknowledgeQuery": "Ik kan u helpen het probleem met uw apparaat te onderzoeken. Laten we het probleem controleren en oplossen"
            },
            "declineScriptMsg": "Ik wil het Nexthink script niet uitvoeren, help me met een andere oplossing",
            "timezone": {
                "primaryBtn": "Ja, ga verder",
                "secondaryBtn": "Nee, niet bijwerken",
                "successMsg": "Tijdzone-detectie is ingesteld op automatisch",
                "successMsgOnList": "Tijdzone-detectie is ingesteld op automatisch",
                "failureMsg": "Tijdzone-configuratie kon niet worden bijgewerkt",
                "progressMsg": "De tijdzone-instellingen worden bijgewerkt",
                "disclaimer": "Houd er rekening mee dat deze actie is ontworpen om de tijdzoneservice automatisch in te stellen, zodat Windows de desktopklok kan bijwerken op basis van de gedetecteerde locatie.",
                "acknowledgeQuery": "Ik kan u helpen uw systeemtijd- en tijdzone-instellingen te herstellen. De meeste tijdgerelateerde problemen, zoals klokdrift, onjuiste tijdstempels, mislukte authenticatiecodes of onjuiste vergadertijden, worden veroorzaakt door een onjuiste tijdzone of uitgeschakelde automatische synchronisatie. Klik op de onderstaande knop om uw Windows-tijd- en tijdzoneconfiguratie automatisch te detecteren en te herstellen."
            },
            "chooseBrowser": "Kies een browser voor de cache-opruimactie",
            "outlookAutoComplete": {
                "primaryBtn": "Ja, Outlook-cache wissen",
                "secondaryBtn": "Nee, Outlook-cache niet wissen",
                "successMsg": "Outlook-autocompletecache gewist",
                "successMsgOnList": "Outlook-autocompletecache gewist",
                "failureMsg": "Outlook-autocompletecache kon niet worden gewist",
                "progressMsg": "Outlook-autocompletecache wordt gewist",
                "disclaimer": "Houd er rekening mee dat het wissen van de Outlook-autocompletecache opgeslagen e-mailadresvoorstellen verwijdert. Deze actie kan niet ongedaan worden gemaakt.",
                "acknowledgeQuery": "Ik kan u helpen de cache voor automatisch aanvullen van Outlook te herstellen. Klik op de onderstaande knop om het automatisch aanvullen van Outlook automatisch te herstellen."
            },
            "restartZscalar": {
                "primaryBtn": "Ja, ga verder",
                "secondaryBtn": "Nee, Zscaler niet opnieuw starten",
                "successMsg": "Zscaler opnieuw gestart",
                "successMsgOnList": "Zscaler opnieuw gestart",
                "failureMsg": "Zscaler kon niet opnieuw worden gestart",
                "progressMsg": "Zscaler-services worden opnieuw gestart",
                "disclaimer": "Houd er rekening mee dat het opnieuw starten van Zscaler uw internetverbinding en werkapplicaties kort kan onderbreken. Dit duurt meestal minder dan een minuut.",
                "acknowledgeQuery": "Ik kan u helpen problemen met Zscaler-services op te lossen. Klik op de onderstaande knop om uw Zscaler-problemen op te lossen."
            },
            "onedrive": {
                "primaryBtn": "Ja, OneDrive repareren",
                "secondaryBtn": "Nee, de OneDrive-reparatie niet uitvoeren",
                "successMsg": "De OneDrive-reparatie is voltooid",
                "successMsgOnList": "De OneDrive-reparatie is voltooid",
                "failureMsg": "De OneDrive-reparatieactie kon niet succesvol worden voltooid",
                "progressMsg": "OneDrive-reparatie wordt uitgevoerd",
                "disclaimer": "Houd er rekening mee dat het repareren van OneDrive ertoe leidt dat lokale bestanden met de cloud worden gesynchroniseerd en mogelijk aangepaste synchronisaties voor Onedrive kan verbreken",
                "acknowledgeQuery": "Ik kan u helpen problemen met OneDrive op te lossen. Klik op de onderstaande knop om uw OneDrive-problemen op te lossen."
            },
            "smartcard": {
                "primaryBtn": "Ja, Smartcard verwijderen",
                "secondaryBtn": "Nee, de Smartcard niet verwijderen",
                "successMsg": "De Microsoft Smartcard is verwijderd",
                "successMsgOnList": "De Microsoft Smartcard is verwijderd",
                "failureMsg": "Het is niet mogelijk de Microsoft Smartcard te verwijderen",
                "progressMsg": "Microsoft Smartcard wordt verwijderd",
                "disclaimer": "Het uitvoeren van deze actie kan tot 1 minuut duren.",
                "acknowledgeQuery": "Ik kan u helpen problemen met de Microsoft Smart Card Reader op te lossen. Klik op de onderstaande knop om uw Smart Card-problemen op te lossen."
            },
            "errorFetchingReport": "Sorry, ik kon het rapport niet ophalen. Probeer het later opnieuw.",
            "automatedFix": "Automatische oplossing",
            "automatedFixConsent": "Ik kan dit probleem op uw apparaat oplossen. Wilt u dat ik de automatische oplossing start?",
            "primaryButton": "Ja, start de automatische oplossing",
            "teamViewerReset": {
                "primaryBtn": "Ja, ga verder",
                "secondaryBtn": "Nee, niet opnieuw instellen",
                "successMsg": "Teamviewer-diensten zijn opnieuw ingesteld",
                "successMsgOnList": "Teamviewer-diensten zijn opnieuw ingesteld",
                "failureMsg": "Het is niet mogelijk om de Teamviewer-diensten opnieuw in te stellen",
                "progressMsg": "Teamviewer-diensten worden opnieuw opgestart",
                "disclaimer": "Met deze actie worden uw teamviewer-diensten opnieuw ingesteld en wordt uw teamviewer-app opnieuw gestart. Zorg ervoor dat uw werk is opgeslagen voordat u verdergaat",
                "acknowledgeQuery": "Ik kan u helpen Teamviewer te resetten. Klik op de onderstaande knop om door te gaan."
            },
            "zoomUninstall": {
                "primaryBtn": "Ja, Zoom verwijderen",
                "secondaryBtn": "Nee, niet verwijderen",
                "successMsg": "Zoom verwijderd",
                "successMsgOnList": "Zoom verwijderd",
                "failureMsg": "Kan Zoom niet verwijderen",
                "progressMsg": "De-installatie van Zoom wordt uitgevoerd",
                "disclaimer": "Deze actie verwijdert Zoom van uw apparaat; hiermee worden ook alle configuraties voor Zoom gewist.",
                "acknowledgeQuery": "Ik kan u helpen Zoom te verwijderen. Klik op de onderstaande knop om door te gaan."
            },
            "webexUninstall": {
                "primaryBtn": "Ja, Webex verwijderen",
                "secondaryBtn": "Nee, niet verwijderen",
                "successMsg": "Webex verwijderd",
                "successMsgOnList": "Webex verwijderd",
                "failureMsg": "Kan Webex niet verwijderen",
                "progressMsg": "De-installatie van Webex wordt uitgevoerd",
                "disclaimer": "Deze actie verwijdert Cisco Webex van uw apparaat; hiermee worden ook alle configuraties voor Cisco Webex gewist.",
                "acknowledgeQuery": "Ik kan u helpen Cisco Webex te verwijderen. Klik op de onderstaande knop om door te gaan."
            },
            "recommendedAction": "Aanbevolen actie",
            "noKbArticleFound": "Er zijn geen handmatige stappen of kennisartikelen gevonden voor dit probleem. Er is echter een aanbevolen actie die het mogelijk kan oplossen:"
        },
        "sessions": {
            "title": "Recente Chats",
            "clearAll": "Verwijder alle chats",
            "deleteMessage": "Sessie verwijderen",
            "footer": "Opmerking: Gesprekken van de laatste 30 dagen worden opgeslagen.",
            "recentChatTitle": "Chatgeschiedenis (30 dagen)",
            "noRecentChat": "Geen recente chats",
            "startNewChat": "Begin nieuwe chat",
            "learnMore": "Meer leren.",
            "learnMoreTooltip": "Volgens het MyHelp-retentiebeleid zijn uw recente chats 30 dagen beschikbaar, tenzij u de recente chats verwijdert met behulp van de verwijder- of alles wissen-knoppen."
        },
        "search": "E.ON Search",
        "feedbackMsg": "Bedankt voor uw Feedback! We waarderen uw hulp bij het verbeteren van onze diensten.",
        "contactNumberPlaceholder": "Contactnummer met landcode",
        "incidentDetailsLabel": "Samenvatting van het incident",
        "contactNumberLabel": "Voer alstublieft uw voorkeurscontactnummer in",
        "incError": "Voer geldige incidentgegevens in",
        "contactError": "Voer een geldig telefoonnummer in",
        "searchAsk": "Beschrijf je probleem, bijv. wachtwoord resetten",
        "teamsInsights": {
            "specifyDateTime": "Kunt u de datum en tijd waarop dit is gebeurd specificeren, evenals de betreffende vergadering of chat?",
            "date": "Datum",
            "getMeetings": "Vergaderingen ophalen",
            "cancel": "Annuleren",
            "noMeetings": "Geen vergaderingen gevonden voor de geselecteerde datum.",
            "meetingInstruction": "Selecteer de specifieke vergadering/oproep die door de kwaliteitsproblemen is beïnvloed.",
            "identifyIssue": "Probleem identificeren",
            "issueDetectionCompleted": "Probleemdetectie voltooid.",
            "detectingIssues": "Problemen met de vergadering worden gedetecteerd",
            "recommendedActions": "Aanbevolen acties:",
            "noInsightsFound": "Geen inzichten gevonden voor het geselecteerde gesprek.",
            "meetingList": "Vergader-/oproeplijst",
            "fetchingMeetings": "Alle Teams-vergaderingen van vandaag worden opgehaald",
            "windowsOnly": "Vergaderinzichten zijn alleen beschikbaar voor gesprekken waaraan is deelgenomen met Windows-apparaten.",
            "confirmCreateIncident": "Wilt u een incidentticket aanmaken voor het probleem dat in de vergadering is gedetecteerd?",
            "getMeetingsCancelMsg": "Verzoek om vergaderingen op te halen geannuleerd.",
            "identifyIssueCancelMsg": "Verzoek om probleem te identificeren geannuleerd.",
            "createIncidentCancelMsg": "Verzoek om incident aan te maken geannuleerd.",
            "noIssueFoundInstruction": "We hebben verschillende prestatie-indicatoren aan uw kant bekeken en alles ziet er goed uit. Als u problemen heeft ondervonden tijdens uw oproep/vergadering, ligt de oorzaak daarom zeer waarschijnlijk bij de andere deelnemers.",
            "report": {
                "lowWifiRootCause": "Uw WiFi-signaal was tijdens het gesprek zwak en dit kan kwaliteitsproblemen tijdens het gesprek hebben veroorzaakt. Controleer uw afstand tot de router als u verbonden was via een thuis-/extern netwerk.",
                "networkIssueRootCauseManaged": "Het lijkt erop dat u verbonden was vanuit een E.ON-kantoor en netwerkproblemen heeft ondervonden die de vergaderkwaliteit hebben beïnvloed. Overweeg een incidentticket te openen om dit te melden en vermeld in het ticket op welke locatie u zich bevond.",
                "networkIssueRootCauseUnmanaged": "Het lijkt erop dat u niet verbonden was vanuit een E.ON-kantoor en mogelijk netwerkproblemen heeft ondervonden die de vergaderkwaliteit hebben beïnvloed. Controleer de stabiliteit van uw lokale WiFi- of internetverbinding. Gebruik indien mogelijk een bekabelde verbinding of kom dichter bij uw WiFi-router om de netwerkprestaties te verbeteren.",
                "noDataRootCause": "Er waren geen inzichten beschikbaar voor deze parameter tijdens het gesprek.",
                "noIssueRootCause": "Geen probleem gedetecteerd voor deze parameter.",
                "noIssueRecommendation": "Geen actie vereist.",
                "failed": "Mislukt",
                "checking": "Controleren",
                "okay": "Oké",
                "na": "N.v.t.",
                "audio": "Audio",
                "video": "Video",
                "deviceCpuUsage": {
                    "displayName": "CPU-gebruik van apparaat",
                    "rootCause": "We hebben tijdens het gesprek een hoge CPU-belasting op uw apparaat gedetecteerd. Controleer of er achtergrondprocessen of apps open en actief waren tijdens het gesprek en voorkom dat er te veel apps tegelijk openstaan, zodat de hardwareprestaties van het apparaat aan de vergadering kunnen worden toegewezen.",
                    "recommendation": "Sluit onnodige achtergrondtoepassingen tijdens gesprekken om de CPU-belasting te verlagen."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Geheugengebruik van apparaat",
                    "rootCause": "We hebben tijdens het gesprek een hoog geheugengebruik op uw apparaat gedetecteerd. Controleer of er achtergrondprocessen of apps open en actief waren tijdens het gesprek en voorkom dat er te veel apps tegelijk openstaan, zodat de hardwareprestaties van het apparaat aan de vergadering kunnen worden toegewezen.",
                    "recommendation": "Sluit onnodige achtergrondtoepassingen tijdens gesprekken om het geheugengebruik te verlagen."
                },
                "wifiSignalQuality": {
                    "displayName": "WiFi-signaalkwaliteit",
                    "recommendation": "Ga dichter bij uw router zitten of schakel over naar een sterkere WiFi-signaalbron."
                },
                "audioJitter": {
                    "displayName": "Audiojitter"
                },
                "audioJBDelay": {
                    "displayName": "Audio-JB-vertraging"
                },
                "audioRecvLossRate": {
                    "displayName": "Verliespercentage audio-ontvangst"
                },
                "audioRtt": {
                    "displayName": "Audio-retourtijd"
                },
                "videoRtt": {
                    "displayName": "Video-retourtijd"
                },
                "videoRecvLossRate": {
                    "displayName": "Verliespercentage video-ontvangst"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "Middenfrequentie van WiFi-kanaal (kHz)",
                    "rootCause": "U gebruikt een 2,4 GHz WiFi-verbinding, wat vaak problemen met de gesprekskwaliteit veroorzaakt. Overweeg om over te schakelen naar een 5 GHz WiFi-band of hoger.",
                    "recommendation": "Schakel over naar een 5 GHz (of hogere) WiFi-band om de gesprekskwaliteit te verbeteren."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Netwerkwijziging gedetecteerd",
                    "rootCauseManaged": "We hebben WiFi- of Access Point-wijzigingen vastgesteld tijdens uw gesprek in een E.ON-kantoor. Dit kan een onderbreking van het gesprek hebben veroorzaakt. Als u zich niet met uw apparaat heeft verplaatst, meld dit dan alstublieft als een incidentticket.",
                    "rootCauseUnmanaged": "We hebben vastgesteld dat u niet verbonden was vanuit een E.ON-locatie. Controleer of uw WiFi-verbinding stabiel is, aangezien netwerkproblemen de vergaderkwaliteit kunnen beïnvloeden."
                }
            }
        },
        "rightSidebar": {
            "panelLabel": "Lopende activiteiten",
            "closePanel": "Activiteitenpaneel sluiten",
            "openPanel": "Activiteitenpaneel openen",
            "emptyState": "Nog geen lopende activiteiten.",
            "ticketPrefix": "Ticket",
            "openedAtPrefix": "Geopend:",
            "showTicketDetails": "Ticketoverzicht weergeven",
            "defaultTaskLabel": "Nexthink-actie"
        }
    },
    "snow": {
        "welcomeNote": "Hieronder vindt u een overzicht van uw open incidenttickets, uw verzoeken en uw IT-assets.",
        "tabName": {
            "incidents": "Incidenten",
            "orders": "Bestellingen",
            "itResources": "IT-bronnen",
            "incidentsTable": {
                "noData": "Geen beschikbare gegevens",
                "btnText": "Nieuw incident openen",
                "ongoing": "Lopend",
                "closed": "Gesloten",
                "headlineText": "Incidenten"
            },
            "orderTable": {
                "number": "Nummer",
                "catItem": "Cat Item",
                "approvalSet": "Goedkeuringsset",
                "state": "Status",
                "dueDate": "Vervaldatum",
                "createdOn": "Aangemaakt op",
                "noData": "Geen beschikbare gegevens",
                "btnText": "Bestel IT-diensten",
                "headlineText": "Bestellingen",
                "tooltipText": "Vraag en beheer IT-apparatuur, software, licenties of diensten aan"
            },
            "itResourcesTable": {
                "modelCategory": "Modelcategorie",
                "model": "Model",
                "computerName": "Computernaam",
                "serialNumber": "Serienummer",
                "serviceValue1": "Servicewaarde1",
                "serviceValue2": "Servicewaarde2",
                "noData": "Geen beschikbare gegevens",
                "btnText": "Open een ticket voor IT-bronnen",
                "headlineText": "Mijn assets"
            }
        }
    },
    "moveTabAndTiles": {
        "tabNames": "Tabblad",
        "favourite": "Favoriet",
        "categorizeTiles": "Gepersonaliseerd dashboard",
        "enterTabName": "Voer tabbladnaam in",
        "tabNameError": "Voer een unieke tabbladnaam in, met minimaal 2 tot maximaal 20 tekens!",
        "tabInputLabel": "Tabbladnaam",
        "addTabButton": "Tabblad toevoegen",
        "personalizeTab": "Tabbladen personaliseren",
        "personalizeTiles": "Tegels personaliseren",
        "addTab": "Nieuw tabblad toevoegen",
        "removeTabConfrim": "Weet u zeker dat u het tabblad wilt verwijderen",
        "with": " met",
        "cardIn": "tegels in?",
        "actionUndone": "Deze actie kan niet ongedaan worden gemaakt.",
        "categorizeTilesTitle": "Hernoem tabbladen, verwijder tabbladen en verplaats tegels binnen tabbladen",
        "addTabTitle": "Nieuw tabblad toevoegen. U kunt maximaal 4 tabbladen maken.",
        "organiseTilesTitle": "Om de positie van de tegels te verplaatsen"
    },
    "dataTable": {
        "pagingData": "Items per pagina",
        "itemString": "items",
        "ofString": "van"
    },
    "tourData": {
        "userActions": {
            "back": "Terug",
            "close": "Sluiten",
            "last": "Voltooien",
            "next": "Volgende",
            "step": "Stap",
            "of": "van",
            "open": "Open de dialoog",
            "skip": "Overslaan",
            "start_tour": "Start rondleiding",
            "tour_info": "Wilt u dat we u de basisfunctionaliteiten laten zien met een snelle begeleide rondleiding? Het duurt slechts 1-2 minuten..."
        },
        "tile": {
            "step1": "Gebruik MyHelp om uw typische werkapplicaties te vinden of stel een vraag over E.ON-bronnen, bijvoorbeeld IT, uw projecten, trainingen, bedrijfsbeleid en nog veel meer.",
            "step2": "U kunt meer te weten komen over MyHelp en zijn functies, antwoorden vinden op veelgestelde vragen en nuttige tips en trucs leren in de gebruikersdocumentatie.",
            "step3": "U kunt de voorkeurstaal hier altijd nog wijzigen.",
            "step4": "U kunt uitloggen door hier te klikken.",
            "step5": "Begin een nieuw gesprek, open je laatste chats om verder te gaan waar je gebleven was of start een E.ON zoekopdracht door op de loep te drukken",
            "step6": "Uw gepersonaliseerde dashboard stelt u in staat om uw favoriete werkapplicaties te organiseren en te openen. Zoek naar een app en voeg deze toe met het plussymbool. Maak nieuwe tabbladen en herschik apps indien nodig."
        },
        "tab": {
            "step1": "U kunt een nieuw tabblad toevoegen door hier te klikken.",
            "step2": "Klik hier om de volgorde van de tegels te organiseren.",
            "step3": "Hier kunt u tabbladen hernoemen en organiseren."
        },
        "chat": {
            "step1": "Beschrijf je IT-probleem",
            "step1_description": "Ontvang stapsgewijze hulp voor veelvoorkomende IT-problemen – gebaseerd op de kennisdatabanken van E.ON IT-Support. Indien nodig leidt MyHelp je ook door naar het juiste IT-supportkanaal.",
            "step2": "Veelvoorkomende IT-vraagstukken ontdekken",
            "step2_description": "Deze voorbeelden laten veelvoorkomende IT-vraagstukken zien waarbij MyHelp je stap voor stap kan ondersteunen.",
            "navigation": "Vind je weg in MyHelp",
            "headerNavigation_description": "Gebruik de navigatie bovenaan om Ask MyHelp, Dashboard en andere beschikbare pagina’s te openen.",
            "sidebarNavigation_description": "Gebruik het zijmenu om pagina’s te openen, een nieuwe chat te starten of eerdere gesprekken te bekijken.",
            "support_description": "Open My IT-Support voor hulp bij je IT-probleem en de juiste ondersteuningsoptie.",
            "step3": "Krijg sneller toegang tot je apps",
            "step3_description": "Gebruik het dashboard om vaak gebruikte toepassingen op te slaan en je persoonlijke werkruimte te creëren.",
            "step4": "Start een nieuwe chat of ga verder met eerdere gesprekken",
            "step4_description": "Gebruik de zijbalk om een nieuw gesprek te starten of snel terug te keren naar eerdere chats."
        }
    },
    "allApps": {
        "addAppsBtn": "Apps toevoegen",
        "addAppsInfo": "Klik op Apps toevoegen om te beginnen",
        "addAppsTitle": "Maak je eigen gepersonaliseerde werkruimte",
        "addAppsDesc": "Voeg je meest gebruikte applicaties toe voor snellere toegang tot de tools die je elke dag gebruikt",
        "customTileButton": "Aangepaste kaart toevoegen",
        "CustomTileHeading": "Aangepaste kaart",
        "customTileTitleLabel": "Kaarttitel",
        "customTileSubTitle": "Kaartbeschrijving",
        "customTileUrlLabel": "Kaartlink",
        "createCardBtn": "Kaart maken",
        "modalHeading": "Apps op E.ON",
        "modalDesc": "Zoek of selecteer een app om toe te voegen aan de startpagina",
        "titleRequired": "Kaarttitel is vereist",
        "linkRequired": "Kaartlink is vereist",
        "searchPlaceholder": "Zoek app"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Onboardingportaal",
        "heading": "Onboardingportaal",
        "subHeading": "Bekijk uw app, voeg nieuwe toe en deel beheertoegang met uw team.",
        "modules": {
            "home": "Home",
            "apps": "Apps",
            "appsLabel": "Apps",
            "qna": "Q&A",
            "qnaLabel": "Vraag en antwoord",
            "review": "Beoordeling",
            "reviewLabel": "Beoordeling",
            "onboardApp": "Nieuwe app toevoegen",
            "manageApp": "Apps beheren",
            "defaultApps": "Standaard apps",
            "onboardQnA": "QnA toevoegen",
            "manageQnA": "QnA beheren",
            "reviewDashboard": "Dashboard beoordelaar",
            "reviewApps": "Apps beoordelen",
            "reviewQnA": "Q&A beoordelen"
        },
        "appOnboardingForm": {
            "formHeading": "Nieuwe app toevoegen",
            "successAlert": "App succesvol toegevoegd!",
            "appTitleLabel": "App-titel",
            "appTitleTooltip": "Te weergeven app-naam",
            "appTitlePlaceholder": "Te weergeven app-naam",
            "appTitleError": "App-titel is vereist",
            "appSubTitleLabel": "App-ondertitel",
            "appSubTitleTooltip": "Ondertitel van de app",
            "appSubTitlePlaceholder": "Ondertitel van de app",
            "appSubTitleError": "App-ondertitel is vereist",
            "appUrlLabel": "App-URL",
            "appUrlTooltip": "Doel-URL van de app",
            "appUrlPlaceholder": "Doel-URL van de app",
            "appUrlError": "App-URL is vereist",
            "appKeywordsLabel": "synKeywords (kommagescheiden)",
            "appKeywordsTooltip": "Vul synoniemen in die gebruikers mogelijk gebruiken om de app te vinden en scheid ze door een komma",
            "appKeywordsPlaceholder": "Vul synoniemen in die gebruikers mogelijk gebruiken om de app te vinden en scheid ze door een komma",
            "appKeywordsError": "Trefwoorden zijn vereist",
            "appCompaniesAllowedLabel": "Toegestane bedrijven",
            "appCompaniesAllowedTooltip": "Lijst van alle bedrijven waar deze app is toegestaan. Als toegestaan voor alle, laat leeg.",
            "appCompaniesAllowedInfoMessage": "Lijst van alle bedrijven waar deze app is toegestaan. Als toegestaan voor alle, laat leeg.",
            "appCompaniesAllowedOtherLabel": "Andere toegestane bedrijven",
            "appCompaniesAllowedOtherPlaceholder": "Geef andere toegestane bedrijven op",
            "appCompaniesRestrictedLabel": "Beperkte bedrijven",
            "appCompaniesRestrictedTooltip": "Lijst van alle bedrijven waar deze app NIET is toegestaan. Als er geen beperking is, laat leeg.",
            "appCompaniesRestrictedInfoMessage": "Lijst van alle bedrijven waar deze app NIET is toegestaan. Als er geen beperking is, laat leeg.",
            "appCompaniesRestrictedOtherLabel": "Andere beperkte bedrijven",
            "appCompaniesRestrictedOtherPlaceholder": "Geef andere beperkte bedrijven op",
            "appTooltipLabel": "Tooltip (vermeld alle talen, als er verschillende namen moeten worden weergegeven)",
            "appTooltipTooltip": "Vermeld alle talen, als er verschillende namen moeten worden weergegeven, bijv. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "Vermeld alle talen, als er verschillende namen moeten worden weergegeven, bijv. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Tooltip is vereist",
            "appIconLabel": "App-pictogram uploaden",
            "appIconTooltip": "App-pictogram uploaden",
            "previewAppBtn": "App-voorbeeld",
            "cancelBtn": "Annuleren",
            "closeBtn": "Sluiten",
            "submitAppBtn": "App indienen",
            "updateAppBtn": "App bijwerken",
            "editAppBtn": "App bewerken",
            "appTitlePreview": "Titel",
            "appSubTitlePreview": "Ondertitel",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Trefwoorden",
            "appCompaniesAllowedPreview": "Toegestane bedrijven",
            "appCompaniesRestrictedPreview": "Beperkte bedrijven",
            "appTooltipPreview": "Tooltip",
            "message": "Zodra een app is ingediend, krijgt deze de status In behandeling en doorloopt een gedefinieerde beoordelingscyclus — van In behandeling → Goedgekeurd (onder beoordeling/testen) → In QA (formeel goedgekeurd en wordt geverifieerd) → In productie (live en zichtbaar voor eindgebruikers op MyHelp), of kan worden Afgewezen als het niet aan de criteria voldoet; in dat geval kan de stakeholder het bewerken en opnieuw indienen."
        },
        "qnaOnboardingForm": {
            "formHeading": "Nieuw QnA toevoegen",
            "successAlert": "QnA succesvol toegevoegd!",
            "qnaQuestionLabel": "Vraag",
            "qnaQuestionTooltip": "Voer de vraag in voor het QnA-item",
            "qnaQuestionPlaceholder": "Voer de vraag in",
            "qnaQuestionError": "Vraag is vereist",
            "qnaAnswerLabel": "Antwoord",
            "qnaAnswerTooltip": "Voer het antwoord in voor het QnA-item",
            "qnaAnswerPlaceholder": "Voer het antwoord op de vraag in",
            "qnaAnswerError": "Antwoord is vereist",
            "qnaCategoryLabel": "Categorie",
            "qnaCategoryTooltip": "Selecteer de categorie voor het QnA-item",
            "qnaCategoryPlaceholder": "Selecteer de categorie voor het QnA-item",
            "qnaCategoryError": "Categorie is verplicht",
            "qnaCategoryOtherLabel": "Andere categorie",
            "qnaCategoryOtherPlaceholder": "Voer een aangepaste categorie in",
            "qnaCompaniesAllowedLabel": "Toegestane bedrijven",
            "qnaCompaniesAllowedTooltip": "Lijst van alle bedrijven waar deze app is toegestaan. Als toegestaan voor alle, laat leeg.",
            "qnaCompaniesAllowedInfoMessage": "Lijst van alle bedrijven waar deze app is toegestaan. Als toegestaan voor alle, laat leeg.",
            "qnaCompaniesAllowedOtherLabel": "Andere toegestane bedrijven",
            "qnaCompaniesAllowedOtherPlaceholder": "Geef andere toegestane bedrijven op",
            "qnaCompaniesRestrictedLabel": "Beperkte bedrijven",
            "qnaCompaniesRestrictedTooltip": "Lijst van alle bedrijven waar deze app NIET is toegestaan. Als er geen beperking is, laat leeg.",
            "qnaCompaniesRestrictedInfoMessage": "Lijst van alle bedrijven waar deze app NIET is toegestaan. Als er geen beperking is, laat leeg.",
            "qnaCompaniesRestrictedOtherLabel": "Andere beperkte bedrijven",
            "qnaCompaniesRestrictedOtherPlaceholder": "Geef andere beperkte bedrijven op",
            "previewQnABtn": "QnA-voorbeeld",
            "cancelBtn": "Annuleren",
            "submitQnABtn": "QnA indienen",
            "updateQnABtn": "QnA bijwerken",
            "editQnABtn": "QnA bewerken",
            "addNewQnABtn": "+ QnA toevoegen",
            "qnaQuestionPreview": "Vraag",
            "qnaAnswerPreview": "Antwoord",
            "qnaCompaniesAllowedPreview": "Toegestane bedrijven",
            "qnaCompaniesRestrictedPreview": "Beperkte bedrijven",
            "message": "Zodra een Q&A-vermelding is ingediend, krijgt deze de status In behandeling en doorloopt een gedefinieerde beoordelingscyclus — van In behandeling → Goedgekeurd (onder beoordeling/testen) → In QA (formeel goedgekeurd en wordt geverifieerd) → In productie (live en zichtbaar voor eindgebruikers op MyHelp), of kan worden Afgewezen als het niet aan de criteria voldoet; in dat geval kan de stakeholder het bewerken en opnieuw indienen."
        },
        "manageBtn": "Beheren",
        "refreshBtn": "Vernieuwen",
        "exportBtn": "Exporteren",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Apps exporteren als CSV",
        "exportAppsExcelBtn": "Apps exporteren als Excel",
        "exportQnACsvBtn": "QnA exporteren als CSV",
        "exportQnAExcelBtn": "QnA exporteren als Excel",
        "approveBtn": "Goedkeuren",
        "rejectBtn": "Afwijzen",
        "toQABtn": "Verplaats naar QA",
        "toProdBtn": "Verplaats naar productie",
        "editBtn": "Bewerken",
        "viewBtn": "Bekijken",
        "closeBtn": "Sluiten",
        "dashboard": {
            "appsTitle": "Toegankelijke apps",
            "appsText": "Apps die voor je beschikbaar zijn via eigenaarschap of teamdeling.",
            "qnaTitle": "Vragen en antwoorden",
            "qnaText": "Vragen en antwoorden die voor je beschikbaar zijn via eigenaarschap of teamdeling."
        },
        "modalLabel": {
            "reviewAppTitle": "App beoordelen voor onboarding",
            "reviewQnATitle": "Q&A beoordelen voor onboarding",
            "owner": "Eigenaar",
            "createdOn": "Aangemaakt op",
            "status": "Status",
            "url": "URL",
            "tooltip": "Tooltip",
            "companiesAllowed": "Toegestane bedrijven",
            "companiesRestricted": "Beperkte bedrijven",
            "keywords": "Trefwoorden",
            "reviewerComments": "Beoordelingscommentaar",
            "category": "Categorie",
            "question": "Vraag",
            "answer": "Antwoord",
            "mail": "E-mail"
        },
        "statusLabel": {
            "pending": "In behandeling",
            "approved": "Goedgekeurd",
            "rejected": "Afgewezen",
            "onhold": "In de wacht",
            "unknown": "Onbekend",
            "all": "Alle",
            "inQA": "In QA",
            "inProd": "In productie"
        },
        "activityLabel": {
            "allowed": "Toegestaan",
            "restricted": "Beperkt"
        },
        "tableHeaders": {
            "status": "Status",
            "action": "Actie",
            "icon": "Icoon",
            "title": "Titel",
            "subTitle": "Ondertitel",
            "question": "Vraag",
            "answer": "Antwoord",
            "category": "Categorie",
            "owner": "Eigenaar",
            "description": "Beschrijving",
            "apps": "Apps",
            "qna": "Vraag en antwoord",
            "defaultApps": "Standaard apps",
            "defaultAppsActivity": "Wijzigingen in standaardapps",
            "search": "Zoeken",
            "selectCompany": "Selecteer bedrijf",
            "otherCompany": "Naam ander bedrijf",
            "selectAll": "Alles selecteren",
            "company": "Bedrijf",
            "update": "Bijwerken",
            "comments": "Opmerkingen"
        },
        "noData": {
            "dashboardEmpty": "Er zijn geen apps of Q&A toegevoegd",
            "dashboardAppsEmpty": "Er zijn geen apps toegevoegd",
            "dashboardQnAEmpty": "Er zijn geen Q&A toegevoegd",
            "reviewDashboardEmpty": "Er zijn geen apps of Q&A ingediend voor beoordeling.",
            "reviewAppsEmpty": "Er zijn geen apps ingediend voor beoordeling.",
            "reviewQnAEmpty": "Er zijn geen Q&A ingediend voor beoordeling."
        },
        "manageApp": {
            "heading": "Apps beheren",
            "subHeading": "Alleen apps die u bezit of waartoe u toegang hebt gekregen, worden hier weergegeven."
        },
        "manageQnA": {
            "heading": "QnA beheren",
            "subHeading": "Alleen QnA's die u bezit of waartoe u toegang hebt gekregen, worden hier weergegeven."
        },
        "defaultApps": {
            "heading": "Standaard apps",
            "subHeading": "Dit zijn de standaard apps die beschikbaar zijn voor alle gebruikers. U kunt verzoeken om nieuwe apps aan te voeren of toegang aanvragen om bestaande apps te beheren in het gedeelte Apps beheren.",
            "searchPlaceholder": "Zoek naar apps"
        },
        "reviewDashboard": {
            "heading": "Beoordelingsdashboard",
            "subHeading": "Beoordeel openstaande app-onboardingverzoeken en keur ze goed of wijs ze af. Uw tijdige beoordelingen helpen ons om voor iedereen een relevante en bruikbare app-verzameling te behouden."
        },
        "reviewApps": {
            "heading": "Apps beoordelen",
            "subHeading": "Beoordeel openstaande app-onboardingverzoeken en keur ze goed of wijs ze af. Uw tijdige beoordelingen helpen ons om voor iedereen een relevante en bruikbare app-verzameling te behouden."
        },
        "reviewQnA": {
            "heading": "Q&A beoordelen",
            "subHeading": "Beoordeel openstaande QnA-onboardingverzoeken en keur ze goed of wijs ze af. Uw tijdige beoordelingen helpen ons om voor iedereen een relevante en bruikbare QnA-verzameling te behouden."
        },
        "reviewQueue": {
            "heading": "Beoordelingswachtrij",
            "subHeading": "Controleer en keur goed of wijs aanstaande verzoeken voor app-onboarding af. Uw snelle beoordelingen helpen ons een relevante en nuttige app-verzameling voor iedereen te behouden."
        },
        "activityLog": {
            "heading": "Activiteitenlogboek"
        },
        "quickActions": {
            "title": "Snelle acties",
            "onboardNewApp": "Nieuwe app toevoegen",
            "manageApps": "Apps beheren",
            "defaultApps": "Standaard apps",
            "onboardNewQnA": "Nieuwe vraag en antwoord toevoegen",
            "manageQnA": "Vragen en antwoorden beheren",
            "reviewerDashboard": "Dashboard beoordelaar",
            "reviewApps": "Toegevoegde apps beoordelen",
            "reviewQnA": "Toegevoegde Q&A beoordelen"
        }
    },
    "sourceSelector": {
        "title": "Bron selecteren",
        "allSources": "Alle bronnen",
        "allSourcesDesc": "Zoeken in alle interne E.ON-informatiebronnen",
        "eonKnowledgeBase": "E.ON Kennisdatabase",
        "eonKnowledgeBaseDesc": "Toegang tot algemene bedrijfskennis",
        "eonMyItOrder": "E.ON Mijn IT-bestellingen",
        "eonMyItOrderDesc": "IT-servicebestellingen beheren en volgen",
        "eonItKnowledgeBase": "E.ON IT-kennisdatabase",
        "eonItKnowledgeBaseDesc": "IT-gerelateerde informatie en oplossingen vinden",
        "myGenius": "My Genius",
        "myGeniusDesc": "Interne cursussen en materialen verkennen",
        "confluenceAll": "Confluence (Alle)",
        "confluenceAllDesc": "Samenwerkende documentatie doorzoeken",
        "sharepointAll": "SharePoint (Alle)",
        "sharepointAllDesc": "Gedeelde bestanden en bronnen doorzoeken",
        "eonApps": "E.ON Apps",
        "eonAppsDesc": "Bedrijfsapplicaties ontdekken en gebruiken",
        "hrPolicies": "HR-beleid",
        "hrPoliciesDesc": "Toegang tot HR-beleid en -richtlijnen",
        "compass": "Compass",
        "compassDesc": "E.ON-Intranet verkennen",
        "back": "Terug",
        "search": "Zoeken...",
        "noMatches": "Geen treffers"
    },
    "ailoader": {
        "thinking": "Denken",
        "reading": "Bronnen lezen",
        "processing": "Verwerken",
        "analysing": "Resultaten analyseren",
        "preparing": "Antwoord voorbereiden",
        "working": "Ik ben bezig met je antwoord - dit kan even duren."
    },
    "compassScopeSelector": {
        "title": "Selecteer bedrijfseenheid",
        "iconLabel": "Zoekbereik",
        "localSearch": "Lokaal zoeken",
        "compassWideSearch": "Compass-breed zoeken",
        "resetToCompassWide": "Terugzetten naar Compass-breed zoeken",
        "switchToLocal": "Overschakelen naar lokaal zoeken",
        "localDescription": "Zoeken binnen uw bedrijf en openbare berichten",
        "compassWideDescription": "Zoeken in alle bedrijfseenheden"
    },
    "errorMessages": {
        "azureAiContentViolation": "De reactie is gefilterd omdat de query het contentbeheerbeleid van Azure OpenAI heeft geactiveerd. Wijzig uw query en probeer het opnieuw."
    }
}